import React, { Component, Fragment, useState, useEffect } from 'react';
import Draggabilly from 'draggabilly';
import AssetUploadBig from './AssetUploadBig';
import FileUpload from './FileUpload';
import AssetUpload from './AssetUpload';
import PartyTagModal from './PartyTagModal';
import MatspecHeader from './MatspecHeader';
import MatspecSectionHeader from './MatspecSectionHeader/MatspecSectionHeader';
import DropArea from './DropArea';
import NativeTemplatesComponent from './NativeTemplates/NativeTemplatesComponent';
import {
  copyToClipboard,
  getParamFromUrl,
  highlightMaterial,
  relativePathRegexp,
  setInitialBodyZoom,
  removeDuplicatedFromArray,
} from './Helpers';
import Parser from 'html-react-parser';
import Spinner from '../media/spinner.svg';
import gam from '../media/gam.svg';
import nexusLogo from '../media/nexusLogo.png';
import EditIcon from '../media/list.png';
import Mp3Icon from '../media/mp3.png';
import Placeholder from '../media/placeholder.png';
import {
  Button,
  Checkbox,
  Collapse,
  Form,
  Icon,
  Input,
  message,
  Modal,
  Table,
  Tooltip,
} from 'antd';
import { imageUrlPath, urlPath, devMode } from './Settings';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBars,
  faEye,
  faSpinner,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';
import {
  getAuthHeader,
  handleErrors,
  hasPermission,
  setAuthHeader,
  setUser,
} from '../utils/security';
import 'url-search-params-polyfill';
import _ from 'lodash';
import Interweave from 'interweave';

import { connect } from 'react-redux';
import { setFieldsToSave, setMatspecsToSubmit } from '../redux/actions';

const mapDispatchToProps = (dispatch) => {
  return {
    setFieldsToSave: (key) => dispatch(setFieldsToSave(key)),
    setMatspecsToSubmit: (key) => dispatch(setMatspecsToSubmit(key)),
  };
};

const mapStateToProps = (state) => {
  return {
    fieldsToSave: state.fieldsToSave,
    matspecsToSubmit: state.matspecsToSubmit,
  };
};

const isAdFilledWithData = (ad) => {
  const INTERNAL_PROOF = 517;
  const ARRIVED = 510;
  const COMPLETED = 100005;
  const AD_SERVER_DELIVERED = 100114;
  const NEW_VERSION = 1209;

  const statusCode = ad.status.code;

  return ad.matfilecount === 0 
    && statusCode !== INTERNAL_PROOF 
    && statusCode !== ARRIVED 
    && statusCode !== COMPLETED
    && statusCode !== AD_SERVER_DELIVERED 
    && statusCode !== NEW_VERSION;
};

library.add(faEye);
library.add(faTrash);
library.add(faBars);
library.add(faSpinner);

let oldAdmaterialInput = null;
let currentHoveredCreative = NaN;
let dragStartCreative = null;
let dragEndCreative = null;
let currentDragTarget = null;
let dragStart = false;
let currentHoveredMatspec = null;
let tempModal = null;

// const urlPath = "https://acc-aanleveren.persgroep.nl/xServer";
// const urlPath = "https://newsau-test.integration-x.com/xServer";

/* eslint jsx-a11y/href-no-hash: 0 */

/* eslint no-array-constructor: 0 */
class Matspec extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedMatspecs: [],
      materialIsWorkingLength: 0,
      adBooking: null,
      componentMounted: false,
      data: null,
      dataParam: null,
      fields: null,
      fieldTranslations: this.props.language,
      filterDropdownVisible: false,
      filtered: false,
      scrollViewTriggered: false,
      isInitialized: false,
      matspec: null,
      matspecsBooking: [],
      previewUrl: null,
      searchText: '',
      userBooking: null,
      value: null,
      visible: false,
      translations: this.props.translations,
      defaultActiveKey: this.props.defaultActiveKey,
      isNative: this.props.isNative,
      showExpandAll: this.props.showExpandAll,
      nativeModalVisible: false,
      nativeAdMaterial: false,
      templates: false,
      collapseActiveKey: this.props.defaultActiveKey,
      collapseAllOpen: false,
      checkedAdMaterialsIds: [],
      selectedSections: [],
    };
    this.addCreative = this.addCreative.bind(this);
    this.admaterialUploading = this.admaterialUploading.bind(this);
    this.admaterialUploaded = this.admaterialUploaded.bind(this);
    this.toggleAllCollapse = this.toggleAllCollapse.bind(this);
  }

  setSystemID = (id) => {
    document.getElementsByTagName('body')[0].setAttribute('data-systemid', id);
  };
  /* setRole = role => {
    //role = 'CLIENT';
    if (role !== "CLIENT") {
      this.setState({ internal: true });
      document.getElementsByTagName("body")[0].classList.add("internal");
      document
        .getElementsByTagName("body")[0]
        .setAttribute("data-role", "internal");
    } else {
      this.setState({ internal: false });
      document.getElementsByTagName("body")[0].classList.add("client");
      document
        .getElementsByTagName("body")[0]
        .setAttribute("data-role", "CLIENT");
    }
    this.props.setRole(role);
  }; */

  loadAdSwappedMaterial = (id) => {
    fetch(
      urlPath +
      '/api/loadadmaterial?admaterial=' +
      id +
      '&timezone=' +
      Intl.DateTimeFormat().resolvedOptions().timeZone,
      {
        credentials: 'include',
        headers: getAuthHeader(),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        const dataFormatted = [{ admaterial: data }];
        if (!data.error)
          this.admaterialUploaded(dataFormatted, currentHoveredMatspec, id);
        else this.removeMaterialRow(currentHoveredMatspec, id);
        tempModal.destroy();
      })
      .catch((e) => {
        console.error('Cannot load material!', e);
      });
  };

  checkMaterialUrls = (record, action) => {
    if (action === 'approve')
      document
        .getElementById('approveButton.' + record.id)
        .setAttribute('disabled', 'disabled');
    highlightMaterial(record.id);
    fetch(
      urlPath +
      '/api/loadadmaterial?admaterial=' +
      record.id +
      '&timezone=' +
      Intl.DateTimeFormat().resolvedOptions().timeZone,
      {
        credentials: 'include',
        headers: getAuthHeader(),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.userurls && data.userurls.length > 0) {
          if (action === 'approve') this.admaterialApprove(record);
          if (action === 'deliver') this.admaterialDeliver(record);
          //return true;
        } else {
          this.shouldApprove(record, action);
          //return false;
        }
      })
      .catch((e) => {
        console.error('Cannot load userUrls!', e);
      });
  };

  shouldApprove = (record, action) => {
    const { loadConfig, internal } = this.props;
    let urlMandatoryForFileTypes = internal
      ? loadConfig['web.uploadadmaterial.internal.urlmandatoryforfiletypes']
      : loadConfig['web.uploadadmaterial.customer.urlmandatoryforfiletypes'];
    //console.log("urlMandatoryForFileTypes", urlMandatoryForFileTypes);
    let urlMandatoryForFileTypesMatch = false;

    for (let i = 0; i < urlMandatoryForFileTypes.length; i++) {
      if (
        urlMandatoryForFileTypes[i].toLowerCase() ===
        record.format.toLowerCase()
      ) {
        urlMandatoryForFileTypesMatch = true;

        break;
      }
    }
    if (
      (loadConfig.adMaterialRequireUrl || urlMandatoryForFileTypesMatch) &&
      !record.inputfilename.includes('thirdpartytag_')
    ) {
      Modal.error({
        title: this.props.translations.unsubmittedUrl,
        footer: null,
        onOk: () => this.updateBooking(record.materialSpecificationId, true),
        content: (
          <span>
            <p className="d-none" data-translationkey="unsubmittedUrl">
              {this.props.translations.unsubmittedUrl}
            </p>
            <label className="d-none" data-translationkey="placeUrl">
              {this.props.translations.placeUrl}
            </label>
            <Input
              data-translationkey="placeUrl"
              placeholder={this.props.translations.placeUrl}
              prefix={<Icon type="link" style={{ color: 'rgba(0,0,0,.25)' }} />}
              type="url"
              onChange={(e) => this.checkValidUrl(e.target.value, record.id)}
            />
            <span
              className="d-none"
              id={'validPopUpUrlMsg.' + record.id}
              data-translationkey="invalidUrl"
            >
              {this.props.translations.invalidUrl}
            </span>
          </span>
        ),
      });
      if (action === 'approve')
        document
          .getElementById('approveButton.' + record.id)
          .removeAttribute('disabled');
      return false;
    } else {
      if (action === 'approve') this.admaterialApprove(record);
      if (action === 'deliver') this.admaterialDeliver(record);
    }
  };

  admaterialApprove = (record) => {
    let targetUrl = urlPath + '/api' + record.actions.APPROVE;
    const matspecId = record.materialSpecificationId;
    fetch(targetUrl, {
      method: 'POST',
      credentials: 'include',
      headers: getAuthHeader(),
    })
      .then((response) => {
        //console.log("Approved admaterial", response.text());
        //document.getElementById('approveButton.' + record.id).style.display = 'none';
        /*this.modifyMaterialRow(record.materialSpecificationId, record.id, 100010, record.preview? (imageUrlPath + record.preview.url): (record.original && record.original.length > 0)? ((record.original[0].url? imageUrlPath: "") + record.original[0].url): "");
				  setTimeout(function() {
					  window.location.reload();
				  }, 100);*/
        setTimeout(() => this.updateBooking(matspecId, true), 1000);
        document
          .getElementById('approveButton.' + record.id)
          .removeAttribute('disabled');
      })
      .catch((e) => {
        console.error('Cannot approve', e);
      });
  };

  admaterialDeliver = (record) => {
    let targetUrl = urlPath + '/api' + record.actions.DELIVER;
    const matspecId = record.materialSpecificationId;
    fetch(targetUrl, {
      method: 'POST',
      credentials: 'include',
      headers: getAuthHeader(),
    })
      .then((response) => {
        //console.log("Deliver admaterial", response.text());
        setTimeout(() => this.updateBooking(matspecId, true), 1000);
        document
          .getElementById('deliverButton.' + record.id)
          .removeAttribute('disabled');
      })
      .catch((e) => {
        console.error('Cannot deliver', e);
      });
  };

  getZippedThirdPartyTag = (data) => {
    const indexFile = data.original.filter(
      (file) => file.serverfilename === 'index.html'
    );
    console.log(indexFile);

    return (
      (indexFile &&
        indexFile[0].htmlattributes &&
        indexFile[0].htmlattributes.clicktag &&
        indexFile[0].htmlattributes.clicktag.length) ||
      false
    );
  };

  checkCreativesUrls = (matspec) => {
    const { loadConfig, internal } = this.props;
    let missingUrlIds = [];
    let urlMandatoryForFileTypes = internal
      ? loadConfig['web.uploadadmaterial.internal.urlmandatoryforfiletypes']
      : loadConfig['web.uploadadmaterial.customer.urlmandatoryforfiletypes'];
    const materials = matspec.admaterial;
    for (let i = 0; i < materials.length; i++) {
      const record = materials[i];

      const hasUrl = RegExp(/index.html/gm).test(record.inputfilename)
        ? this.getZippedThirdPartyTag(record)
        : record.userurls.length > 0;

      if (!hasUrl) {
        for (let z = 0; z < urlMandatoryForFileTypes.length; z++) {
          if (
            record.format &&
            urlMandatoryForFileTypes[z].toLowerCase() ===
            record.format.toLowerCase()
          ) {
            missingUrlIds =
              missingUrlIds && missingUrlIds.concat(record.externalid);
            //return record.externalid;
          }
        }
      }
    }
    if (missingUrlIds.length > 0) return missingUrlIds;
    return false;
  };
  getObjectDifference = (object, base) => {
    function changes(object, base) {
      return _.transform(object, function (result, value, key) {
        if (!_.isEqual(value, base[key])) {
          result[key] =
            _.isObject(value) && _.isObject(base[key])
              ? changes(value, base[key])
              : value;
        }
      });
    }

    return changes(object, base);
  };

  updateBooking = async (
    matspecId,
    showMessage,
    newBooking,
    uploadResponse
  ) => {
    //    return;
    await new Promise((resolve) => setTimeout(resolve, 1000));
    message.config({
      maxCount: 1,
    });
    //const dataParam = getParamFromUrl(window.top.location.href, "data");
    const langParam = getParamFromUrl(window.top.location.href, 'language');
    if (!matspecId) {
      //console.error("Cannot load booking for no matspec", matspecId);
      return;
    }
    let loadbookingUrl = urlPath + '/api/loadbooking?matspec=' + matspecId;
    if (langParam) loadbookingUrl = loadbookingUrl + '&language=' + langParam;
    this.setState({ updatingMatspec: true });
    loadbookingUrl =
      loadbookingUrl +
      '&timezone=' +
      Intl.DateTimeFormat().resolvedOptions().timeZone;
    fetch(loadbookingUrl, { credentials: 'include', headers: getAuthHeader() })
      .then(handleErrors)
      .then((response) => response.json())
      .then(async (data) => {
        if (!data || !data.matspecs)
          return this.updateBooking(matspecId, false, null);
        await this.props.updateBooking(data);
        if (uploadResponse) this.props.uploadFinished(uploadResponse);
        let objectDiff = false;
        let bookingComparison = null;
        const currentMatspec = data.matspecs.filter(
          (matspec) => matspec.id === matspecId
        );
        const materialIsWorking = currentMatspec[0].admaterial.filter(
          (admaterial) => admaterial.status.code === 3
        );
        //console.log("materialIsWorking", materialIsWorking);
        this.setState({
          materialIsWorkingLength: materialIsWorking.length,
        });
        const currentBooking = this.state.getBooking;
        if (!currentBooking) {
          this.setState({ getBooking: data });
        }
        //this.updateMatspec(matspecId, data);
        this.setState({ updatingMatspec: false });
        if (tempModal) tempModal.destroy(); //THIS IS THE MODAL FOR SWAPPED MATERIALS
        this.updateMatspec(matspecId, data);
        //materialIsWorking.map(material => this.modifyMaterialRow(matspecId, material.id, 3, Spinner))
        if (
          //!currentBooking ||
          materialIsWorking.length > 0
        ) {
          const updateData = () => {
            this.updateBooking(matspecId, false, data);
            /*if(materialIsWorking.length !== this.state.materialIsWorkingLength){
              this.updateMatspec(matspecId, data);
            }*/
          };
          //_.debounce(updateData(),2000);
          setTimeout(() => updateData(), 1500);
          return;
        } else {
          this.setState({ getBooking: null });
          this.updateMatspec(matspecId, data);
          /* setTimeout(() => {
            const currentMatspecPanel = document.getElementById(
              "matspecPanel." + matspecId
            );
            if (currentMatspecPanel) {
              if (
                currentMatspecPanel
                  .querySelectorAll(".ant-collapse-header")[0]
                  .getAttribute("aria-expanded") === "false"
              ) {
                currentMatspecPanel
                  .querySelectorAll(".ant-collapse-header")[0]
                  .click();
              }
            }
          }, 250); */
        }
        this.matspecIsApproving(matspecId, false);
        if (this.props.refreshBooking) {
          this.props.refreshBooking(false);
          this.setState({ checkedMatspecs: [] });
        }
      })
      .catch((e) => {
        console.error('Cannot load booking: ' + e, e);
        setTimeout(() => {
          this.updateBooking(matspecId, false, null, uploadResponse);
        }, 2500);
      });
  };

  updateMatspec = async (matspecId, data) => {
    const { matspecsBooking } = this.props;
    //this.setState({ matspecsBooking: data.matspecs });
    //const arr = data.matspecs.map(matspec => matspec.admaterial.map(item => item.status.code))
    //console.log('arr' , arr)
    await this.props.updateMatspec(data.matspecs);
    this.setState({ randomNumber: Math.random() });
    this.checkDummyCreative(matspecId);
  };

  shouldMatspecApprove = (matspec, e) => {
    e.stopPropagation();
    e.preventDefault();
    const target = e.target;
    let loadbookingUrl = urlPath + '/api/loadbooking?matspec=' + matspec.id;
    loadbookingUrl =
      loadbookingUrl +
      '&timezone=' +
      Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.matspecIsApproving(matspec.id, true, target);
    fetch(loadbookingUrl, { credentials: 'include', headers: getAuthHeader() })
      .then(handleErrors)
      .then((response) => response.json())
      .then((data) => {
        console.log('Loaded booking:', data);
        for (let i = 0; i < data.matspecs.length; i++) {
          const currentMatspec = data.matspecs[i];
          if (matspec.id === currentMatspec.id) {
            const urlCheck = this.checkCreativesUrls(currentMatspec);
            return this.matspecApprove(matspec, urlCheck, target);
          }
        }
      })
      .catch((e) => {
        console.error('Cannot load booking: ' + e, e);
      });
  };
  shouldMatspecDeliver = (e, matspec) => {
    let loadbookingUrl = urlPath + '/api/loadbooking?matspec=' + matspec.id;
    loadbookingUrl =
      loadbookingUrl +
      '&timezone=' +
      Intl.DateTimeFormat().resolvedOptions().timeZone;
    const target = e.target;
    target.setAttribute('disabled', 'disabled');
    //this.setState({matspecIsDelivering: true});
    console.log('loading deliver');

    fetch(loadbookingUrl, { credentials: 'include', headers: getAuthHeader() })
      .then(handleErrors)
      .then((response) => response.json())
      .then((data) => {
        console.log('Loaded booking:', data);
        for (let i = 0; i < data.matspecs.length; i++) {
          const currentMatspec = data.matspecs[i];
          if (matspec.id === currentMatspec.id) {
            const urlCheck = this.checkCreativesUrls(currentMatspec);
            return this.matspecDeliver(matspec, urlCheck, target);
          }
        }
      })
      .catch((e) => {
        console.error('Cannot load booking: ' + e, e);
      });
  };

  matspecIsApproving = (matspecId, value, target) => {
    const button = document.getElementById('matspecApproveButton.' + matspecId);
    if (value) {
      if (target)
        target
          .closest('.matspec-approve-button')
          .classList.add('matspec-button__approving');
      this.setState({ approving: true });
      if (button) button.setAttribute('disabled', 'disabled');
    } else {
      if (target)
        target
          .closest('.matspec-approve-button')
          .classList.remove('matspec-button__approving');
      this.setState({ approving: false });
      if (button) button.removeAttribute('disabled');
    }
  };

  matspecApprove = (matspec, value, target) => {
    const { translations } = this.props;
    if (!value) {
      let targetUrl =
        urlPath +
        '/api/matspecapprove?matspec=' +
        matspec.id +
        '&status=' +
        matspec.status.code;
      fetch(targetUrl, {
        method: 'POST',
        credentials: 'include',
        headers: getAuthHeader(),
      })
        .then((response) => {
          //console.log("Approved admaterial", response.text());
          this.updateBooking(matspec.id, true);
          //this.modifyMaterialRow(record.materialSpecificationId, record.id, 1206, record.preview? (imageUrlPath + record.preview.url): (record.original && record.original.length > 0)? ((record.original[0].url? imageUrlPath: "") + record.original[0].url): "")
        })
        .catch((e) => {
          this.matspecIsApproving(matspec.id, false, target);
          console.error('Cannot approve', e);
        });
    } else {
      Modal.error({
        title: translations.error,
        content: translations.urlMissingCreatives + value.map((val) => val),
      });
      this.matspecIsApproving(matspec.id, false, target);
    }
  };
  matspecDeliver = (matspec, value, target) => {
    const { translations } = this.props;
    if (!value) {
      //this.updateBooking(matspec.id, false);
      matspec.admaterial.map((admaterial) =>
        this.modifyMaterialRow(matspec.id, admaterial.id, 3, null)
      );
      let targetUrl =
        urlPath +
        '/api/matspecdeliver?matspec=' +
        matspec.id +
        '&status=' +
        matspec.status.code;
      fetch(targetUrl, {
        method: 'POST',
        credentials: 'include',
        headers: getAuthHeader(),
      })
        .then((response) => {
          //console.log("delivered admaterial", response.text());
          this.updateBooking(matspec.id, false);
          this.setState({ matspecIsDelivering: false });
          target.removeAttribute('disabled');
          //this.modifyMaterialRow(record.materialSpecificationId, record.id, 1206, record.preview? (imageUrlPath + record.preview.url): (record.original && record.original.length > 0)? ((record.original[0].url? imageUrlPath: "") + record.original[0].url): "")
        })
        .catch((e) => {
          console.error('Cannot deliver', e);
          this.setState({ matspecIsDelivering: false });
          target.removeAttribute('disabled');
          this.updateBooking(matspec.id, false);
        });
    } else {
      Modal.error({
        title: translations.error,
        content: translations.urlMissingCreatives + value.map((val) => val),
      });
      this.setState({ matspecIsDelivering: false });
      target.removeAttribute('disabled');
    }
  };

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.specId !== this.props.specId ||
      (nextProps.language && nextProps.translations !== this.props.translations)
    ) {
      //console.log('Matspec: will receive props', nextProps);
      this.setState({
        fieldTranslations: nextProps.language,
        translations: nextProps.translations || {},
      });

      const headerLangs = document.getElementsByClassName('header-lang');
      if (headerLangs)
        for (let i = 0; i < headerLangs.length; i++) {
          const elem = headerLangs[i];
          const key = elem.getAttribute('data-langid');
          elem.innerHTML = nextProps.translations[key];
        }
      fetch(
        urlPath +
        '/api/noauth/loadallstatuses?language=' +
        nextProps.languageCode
      )
        .then((response) => response.json())
        .then((data) => {
          //console.log("Loaded all statuses");
          this.setState({ statuses: data });
        })
        .catch((e) => console.error('Cannot load statuses', e));
    }
  }

  onSwitchChange = (value, admaterial) => {
    console.log('Switch change', value, admaterial);
    document
      .getElementById('dropzone-AdMaterial.' + admaterial)
      .classList.toggle('party-visible', value);
  };

  getCurrentMaterial = (matspecId, admaterialId) => { };

  handlePartyTag = (
    value,
    matspecId,
    admaterialId,
    descriptionOnly,
    sgCode,
    description,
    pixeltracker,
    userurlValue
  ) => {
    //console.log('3rd party tag processing', matspecId, value);
    //btoa(unescape(encodeURIComponent(value)))
    //btoa(value)
    //const valueFormat = value.replace(/'/g, '"').replace(/“/g, '"').replace(/”/g, '"');
    console.log('handling party tag');
    let valueFormat = value.toString();
    valueFormat = valueFormat.replace(/“/g, '"').replace(/”/g, '"');
    if (descriptionOnly && admaterialId < 0) {
      this.admaterialCreate(admaterialId, 'description', value, matspecId);
    } else {
      this.admaterialUploading(matspecId, admaterialId, descriptionOnly);
      fetch(
        urlPath +
        '/api/upload3partytag?content=' +
        btoa(unescape(encodeURIComponent(valueFormat))) +
        '&matspec=' +
        matspecId +
        (admaterialId > 0 ? '&admaterial=' + admaterialId : '') +
        '&thumbnailsize=50' +
        '&timezone=' +
        Intl.DateTimeFormat().resolvedOptions().timeZone +
        (sgCode ? '&sgcode=' + value : ''),
        {
          method: 'POST',
          credentials: 'include',
          headers: getAuthHeader(),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          //this.updateBooking(matspecId , false);
          if (data.error) {
            console.error('Could not upload file', data.error);
            let newSrc = this.state.originalAdmaterialSrc
              ? this.state.originalAdmaterialSrc
              : '';
            document.getElementById('adThumbnail.' + admaterialId).src = newSrc; // Hide spinner
            newSrc = relativePathRegexp(newSrc);
            const { translations } = this.props;
            Modal.error({
              title: translations.error,
              content:
                data && data.error
                  ? `${translations.preflightError} - ${data.error.substring(
                    0,
                    data.error.indexOf(':')
                  )}`
                  : translations.preflightError,
            });
            this.admaterialUploaded(data, matspecId, admaterialId, false);
            const partyButton = document.getElementById(
              'partyButton.' + admaterialId
            );
            const dropZone = document.getElementById(
              'dropzone-AdMaterial.' + admaterialId
            );
            partyButton && partyButton.classList.remove('d-none');
            dropZone && dropZone.classList.remove('d-none');
          } else {
            this.admaterialUploaded(data, matspecId, admaterialId);
            setTimeout(() => {
              if (description && description.length > 0)
                this.admaterialUpdate(
                  data[0].admaterial.id,
                  'description',
                  description
                );
            }, 500);
            setTimeout(() => {
              if (pixeltracker && pixeltracker.length > 0)
                this.admaterialUpdate(
                  data[0].admaterial.id,
                  'pixeltracker',
                  encodeURIComponent(pixeltracker)
                );
            }, 1000);
            setTimeout(() => {
              if (userurlValue && userurlValue.length > 0)
                this.admaterialUpdate(
                  data[0].admaterial.id,
                  'userurl',
                  encodeURIComponent(userurlValue)
                );
            }, 1500);
          }
        })
        .catch((e) => {
          console.error('Cannot load 3rd party', e);
          this.updateBooking(matspecId, false);
        });
    }
  };

  handleValueChange = (admaterial, field, matspecid, e) => {
    if (admaterial > 0)
      this.admaterialUpdate(admaterial, field, e.target.value);
    else this.admaterialCreate(admaterial, field, e.target.value, matspecid);
  };

  checkValidUrl = (url, admaterial) => {
    const pattern = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
    const target = document.getElementById('validPopUpUrlMsg.' + admaterial);
    if (!target) return true;
    if (!pattern.test(url) && url !== '') {
      target.classList.remove('d-none');
      target.classList.add('error-msg');
      //console.log("Please enter a valid URL.");
      return false;
    } else {
      target.classList.add('d-none');
      target.classList.remove('error-msg');
      this.admaterialUpdate(admaterial, 'userurl', url);
      return true;
    }
  };

  admaterialUpdate = (admaterial, field, value, matspecId) => {

    let urlParams =
      admaterial > 0
        ? '/api/admaterialupdate?admaterial=' +
        admaterial +
        '&' +
        field +
        '=' +
        encodeURIComponent(value)
        : '/api/admaterialcreate?matspec=' +
        matspecId +
        '&' +
        field +
        '=' +
        encodeURIComponent(value) +
        '&timezone=' +
        Intl.DateTimeFormat().resolvedOptions().timeZone;

    fetch(urlPath + urlParams, {
      method: 'PUT',
      credentials: 'include',
      headers: getAuthHeader(),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(
          'AdMaterial.' + admaterial + ' update:',
          field + '=' + value,
          data
        );
        if (field === 'sgcode') {
          this.admaterialUploaded(data, matspecId, admaterial);
        }
      })
      .catch((e) => console.error('Cannot update material', e));
  };
  admaterialCreate = (admaterial, field, value, matspecid) => {
    if (admaterial != oldAdmaterialInput) {
      if (field === 'userurl')
        value = value.startsWith('http') ? value : 'http://' + value;
      fetch(
        urlPath +
        '/api/admaterialcreate?matspec=' +
        matspecid +
        '&' +
        field +
        '=' +
        value +
        '&timezone=' +
        Intl.DateTimeFormat().resolvedOptions().timeZone,
        {
          method: 'POST',
          credentials: 'include',
          headers: getAuthHeader(),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          //console.log("AdMaterial created id:" + data.admaterial.id);
          this.replaceMaterialRow(matspecid, admaterial, data.admaterial);
        })
        .catch((e) => console.error('Cannot create material', e));
    }
    oldAdmaterialInput = admaterial;
  };
  showModal = () => this.setState({ visible: true });
  handleCancel = () => this.setState({ visible: false });

  createDummyCreative = (productionad) => {
    /*console.log(
      "Creating dummy creative, is it a production ad?",
      productionad
    );*/
    const statusCode = 522;
    const actions = productionad
      ? { UPLOAD_ASSET: true, UPLOAD_ADMATERIAL: true }
      : { UPLOAD_ADMATERIAL: true };
    return {
      actions: actions,
      id: -Math.floor(Math.random() * 1000000) + 1,
      externalid: this.props.translations
        ? this.props.translations.optionalCreative
        : 'Optional Creative',
      dummy: true,
      status: {
        code: statusCode,
        //text: this.props.translations.optionalCreative,
        //color: "#eee"
      },
      original: { url: '' },
    };
  };

  removeMaterialRow(matspecId, admaterialId) {
    const matspecsBooking = this.props.matspecsBooking;
    for (let i = 0; i < matspecsBooking.length; i++) {
      const ms = matspecsBooking[i];
      if (matspecId === ms.id || !matspecId)
        for (let j = 0; j < ms.admaterial.length; j++) {
          if (admaterialId === ms.admaterial[j].id) {
            ms.admaterial.splice(j, 1);
            this.setState({ matspecsBooking: matspecsBooking });
            break;
          }
        }
    }
  }

  progressMaterialRow(matspecId, admaterialId) {
    const comp = this;
    highlightMaterial(admaterialId);
    this.modifyMaterialRow(matspecId, admaterialId, 3, Spinner);

    /* setTimeout(() => {
      const row = document.querySelector("tr.AdMaterial_" + admaterialId);
      if (row != null)
        row
          .querySelector(".fileupload-container")
          .classList.add("valid-false", "review-false");
      if (row && comp.props.internal) {
        row
          .querySelector(".fileupload-container")
          .classList.remove("valid-false");
        row.querySelector(".fileupload-container").classList.add("valid-true");
      }
      const element = document.getElementById("partyButton." + admaterialId);
      if (element && !comp.props.internal ) element.classList.add("d-none");
    }, 100); */
  }

  modifyMaterialRow(matspecId, admaterialId, statusCode, previewUrl) {
    const { matspecsBooking } = this.props;
    for (let i = 0; i < matspecsBooking.length; i++) {
      const ms = matspecsBooking[i];
      if (matspecId === ms.id || !matspecId)
        for (let j = 0; j < ms.admaterial.length; j++)
          if (admaterialId === ms.admaterial[j].id && !ms.admaterial[j].dummy) {
            const adm = ms.admaterial[j];
            adm.status = {
              code: statusCode,
              text:
                this.state.statuses &&
                  this.state.statuses.data[statusCode] &&
                  this.state.statuses.data[statusCode].text
                  ? this.state.statuses.data[statusCode].text
                  : statusCode,
              color:
                this.state.statuses &&
                  this.state.statuses.data[statusCode] &&
                  this.state.statuses.data[statusCode].color
                  ? this.state.statuses.data[statusCode].color
                  : '#9FC',
            };
            if (statusCode === 3 && previewUrl) {
              if (adm.original) adm.original.url = previewUrl;
              if (adm.preview) adm.preview.url = previewUrl;
            } /* else {
              if (adm.original && previewUrl) adm.original.url = previewUrl;
              if (adm.preview && previewUrl) adm.preview.url = previewUrl;
            }*/
            this.setState({ matspecsBooking: matspecsBooking });
            break;
          }
    }
  }

  replaceMaterialRow(
    matspecId,
    oldAdmaterialId,
    newAdmaterial,
    reviewCreative,
    matspecStatus
  ) {
    if (!newAdmaterial) {
      console.error(
        'Cannot replace with no admaterial',
        oldAdmaterialId,
        newAdmaterial
      );
      return;
    }
    const { statuses } = this.state;
    const { matspecsBooking } = this.props;
    for (let i = 0; i < matspecsBooking.length; i++) {
      const ms = matspecsBooking[i];
      if (matspecId === ms.id && matspecStatus) {
        ms.status = {
          code: matspecStatus,
          color: statuses.data[matspecStatus].color,
          text: statuses.data[matspecStatus].text,
        };
      }
      if (matspecId === ms.id || !matspecId)
        for (let j = 0; j < ms.admaterial.length; j++)
          if (oldAdmaterialId === ms.admaterial[j].id) {
            newAdmaterial.initialStatus = ms.admaterial[j].initialStatus;
            /* AD-9385 */
            //newAdmaterial.actions = ms.admaterial[j].actions;
            ms.admaterial[j] = newAdmaterial;
            /* AD-9385
                        if(reviewCreative){
							delete ms.admaterial[j].actions.UPLOAD_ADMATERIAL;
							ms.admaterial[j].actions.REVIEW = true;
						}*/
            this.setState({ matspecsBooking: matspecsBooking });
            break;
          }
    }
  }

  downloadMatspec = (e, id) => {
    const target = document
      .getElementById('downloadMatspec.' + id)
      .getAttribute('href');
    if (target === '#') {
      fetch(urlPath + '/api/downloadmatspec?matspec=' + id, {
        credentials: 'include',
        headers: getAuthHeader(),
      })
        .then((response) => response.text())
        .then((data) => {
          //console.log(data);
          if (!data.endsWith('zip') && !data.endsWith('pdf')) {
            Modal.error({
              title: this.props.translations.error,
              content: this.props.translations.errorDownload + ' ' + data,
              onOk: () => console.log('closing'),
              onCancel: () => console.log('closing'),
            });
          } else {
            if (data.endsWith('pdf')) {
              document
                .getElementById('downloadMatspec.' + id)
                .setAttribute('target', '_blank');
              document
                .getElementById('downloadMatspec.' + id)
                .setAttribute('href', data);
              document.getElementById('downloadMatspec.' + id).click();
            } else {
              document
                .getElementById('downloadMatspec.' + id)
                .setAttribute('href', data);
              document.getElementById('downloadMatspec.' + id).click();
            }
          }
        })
        .catch((e) => {
          Modal.error({
            title: this.props.translations.error,
            content: this.props.translations.errorDownload + ' ' + e,
            onOk: () => console.log('closing'),
            onCancel: () => console.log('closing'),
          });
        });
      e.preventDefault();
    }
  };

  toggleAllCollapse = () => {
    const { matspecsBooking, currentTabKey } = this.props;
    const { defaultActiveKey, collapseActiveKey } = this.state;
    console.log('currentTabKey', currentTabKey);
    const ids = [];
    for (let i = 0; i < matspecsBooking.length; i++) {
      ids.push(matspecsBooking[i].id.toString());
    }
    this.setState(
      defaultActiveKey.length < matspecsBooking.length
        ? {
          defaultActiveKey: ids,
          collapseAllOpen: true,
        }
        : {
          defaultActiveKey: [], //collapseActiveKey
          collapseAllOpen: false,
        }
    );
    setTimeout(() => this.props.showOrHideByCreativeType(currentTabKey), 0);
  };

  addCreative(event) {
    const matspecid = event.target.getAttribute('matspec-id');
    const { matspecsBooking } = this.props;

    for (let i = 0; i < matspecsBooking.length; i++) {
      const currentMatspec = matspecsBooking[i];
      const hasEmptyCreative = currentMatspec.admaterial.filter(
        (_) => _.matfilecount === 0
      ).length;
      if (currentMatspec.id.toString() === matspecid) {
        //console.log("Adding creative to", currentMatspec);
        if (!hasEmptyCreative)
          currentMatspec.admaterial.push(
            this.createDummyCreative(currentMatspec.productionad)
          );
        this.setState({ matspecsBooking: matspecsBooking });
        break;
      }
    }
    event.preventDefault();
  }

  admaterialUploading(matspecId, admaterialId, descriptionOnly) {
    //set progress on the admaterial
    console.log(
      'Uploading to MaterialSpecification.' +
      matspecId +
      ', AdMaterial.' +
      admaterialId
    );
    const originalAdmaterial = document.getElementById(
      'adThumbnail.' + admaterialId
    );
    if (!descriptionOnly && originalAdmaterial) {
      this.setState({
        originalAdmaterialSrc: originalAdmaterial.src,
      });
      originalAdmaterial.src = Spinner;
      highlightMaterial(admaterialId);
    }
    this.progressMaterialRow(matspecId, admaterialId);
    //const row = document.querySelector("tr.AdMaterial_" + admaterialId);
    //if (row != null)
    //row.querySelector(".fileupload-container").classList.add("d-none");
    const dropzone = document.getElementById(
      'dropzone-AdMaterial.' + admaterialId
    );
    if (dropzone) dropzone.classList.add('d-none');
    //this.updateBooking(matspecId, false, null, null);
    //document.getElementById("dropzone-AdMaterial." + admaterialId).querySelector('.ix-creative-dropzone').classList.add('d-none')
  }

  checkDummyCreative = (matspecId) => {
    let { config } = this.state;
    let { matspecsBooking } = this.props;
    matspecsBooking.map((matspec) => {
      if (matspec.id === matspecId) {
        const admaterialLength = matspec.admaterial.length - 1;
        const admaterialStatus =
          matspec.admaterial[admaterialLength].status.code;
        if (
          admaterialStatus !== 522 &&
          !matspec.printed &&
          config['web.uploadadmaterial.dummycreative']
        )
          if (document.getElementById('addCreative.' + matspecId))
            document.getElementById('addCreative.' + matspecId).click();
      }
    });
  };

  admaterialUploaded(response, matspecId, oldAdmaterialId, showPopup = true) {
    //replace the dummy/old admaterial with the new one
    console.log(
      'Uploaded',
      response,
      'MaterialSpecification.' + matspecId,
      'AdMaterial.' + oldAdmaterialId
    );
    this.props.unsubmittedChanges(true);
    const { translations } = this.props;
    if (response[0] && response[0].admaterial) {
      //console.log("Response after uploading material:", response[0].admaterial);

      let dropzone = document.getElementById(
        'dropzone-AdMaterial.' + response[0].admaterial.id
      );
      if (!dropzone) {
        dropzone = document.getElementById(
          'dropzone-AdMaterial.' + oldAdmaterialId
        );
      }
      if (dropzone) {
        dropzone.classList.remove('d-none');
      }
    } else {
      if (showPopup) {
        console.error('Could not upload file', response);
        Modal.error({
          title: translations.error,
          content: translations.preflightError,
        });
      } else {
        this.props.unsubmittedChanges(false);
      }
    }
    if (this.state.materialIsWorkingLength === 0)
      this.updateBooking(matspecId, true, null, response);
  }

  deleteMaterialConfirmation = (
    admaterial,
    matspecId,
    status,
    fileUrl,
    initialStatus,
    matfilecount,
    currentMatspec
  ) => {
    highlightMaterial(admaterial);
    Modal.confirm({
      title: this.props.translations.deleteMaterial,
      content: this.props.translations.deleteMaterialMessage,
      okText: this.props.translations.yes,
      okType: 'danger',
      onOk: async () => {
        if (matfilecount > 0) {
          const hasEmptyCreative = currentMatspec.admaterial.filter(
            (_) => _.matfilecount === 0
          ).length !== 0;
          const { loadConfig } = this.props;

          if (hasEmptyCreative && !loadConfig['web.uploadadmaterial.showmultipledummycreatives']) {
            let targetUrl =
              urlPath +
              '/api/admaterialdiscard?matspec=' +
              matspecId +
              '&admaterial=' +
              admaterial +
              '&timezone=' +
              Intl.DateTimeFormat().resolvedOptions().timeZone;
            await fetch(targetUrl, {
              method: 'POST',
              credentials: 'include',
              headers: getAuthHeader(),
            });
          }
        }

        this.deleteMaterial(
          admaterial,
          matspecId,
          status,
          fileUrl,
          initialStatus
        );
        highlightMaterial(admaterial);
      },
      onCancel: () => highlightMaterial(null),
    });
  };

  deleteMaterial(admaterial, matspecId, status, fileUrl, initialStatus) {
    console.log(
      'Deleting: AdMaterial.' +
      admaterial +
      ' MaterialSpecification.' +
      matspecId +
      ' Url:' +
      fileUrl +
      ' Status:' +
      status
    );
    if (admaterial < 1) {
      console.log('Cannot delete AdMaterial.' + admaterial);
      this.removeMaterialRow(matspecId, admaterial);
      return;
    }
    this.progressMaterialRow(matspecId, admaterial);
    let targetUrl =
      urlPath +
      '/api/admaterialdiscard?matspec=' +
      matspecId +
      '&admaterial=' +
      admaterial +
      '&timezone=' +
      Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (initialStatus) {
      targetUrl = targetUrl + '&status=' + initialStatus;
    }
    fetch(targetUrl, {
      method: 'POST',
      credentials: 'include',
      headers: getAuthHeader(),
    })
      .then((response) => response.json())
      .then(async (data) => {
        if (data.admaterial) {
          await this.updateBooking(matspecId, false, null);
          window.location.reload();
          /* this.replaceMaterialRow(matspecId, admaterial, data.admaterial);
          setTimeout(() => {
            document
              .getElementById("dropzone-AdMaterial." + data.admaterial.id)
              .classList.remove(
                "valid-true",
                "valid-false",
                "review-true",
                "review-false"
              );
            document
              .getElementById("dropzone-AdMaterial." + data.admaterial.id)
              .classList.add("valid-true", "review-false");
          }, 200); */
        } else {
          //this should happen for PRINT, for DIGITAL if externalid is not set (when uploaded from thick client), or DIGITAL in 2-step deletion
          this.removeMaterialRow(matspecId, admaterial);
          const { matspecsBooking } = this.props;
          for (let i = 0; i < matspecsBooking.length; i++) {
            const currentMatspec = matspecsBooking[i];
            // eslint-disable-next-line eqeqeq
            if (matspecId == currentMatspec.id) {
              this.setState({ matspecsBooking: matspecsBooking });
              break;
            }
          }
        }
        //window.location.reload();
      })
      .catch((e) => {
        console.error('Cannot discard', e);
        this.modifyMaterialRow(matspecId, admaterial, 1001, '');
      });
  }

  downloadAd = (admaterialId, e) => {
    //console.log(admaterialId);
    highlightMaterial(admaterialId);
    const target = document
      .getElementById('downloadElem.' + admaterialId)
      .getAttribute('href');
    if (target === '#') {
      fetch(urlPath + '/api/downloadmaterial?admaterial=' + admaterialId, {
        credentials: 'include',
        headers: getAuthHeader(),
      })
        .then((response) => response.text())
        .then((data) => {
          console.log(data);
          document
            .getElementById('downloadElem.' + admaterialId)
            .setAttribute('href', data);
          document.getElementById('downloadElem.' + admaterialId).click();
        })
        .catch((e) => console.error('Cannot download ad', e));
      e.preventDefault();
    }
  };

  getStatusCode = (matspecId, materialId) => {
    const { matspecsBooking } = this.props;
    console.log('matspecsBooking', matspecsBooking);
    for (let i = 0; i < matspecsBooking.length; i++) {
      const currentMatspec = matspecsBooking[i];
      if (matspecId === currentMatspec.id)
        for (let z = 0; z < currentMatspec.admaterial.length; z++) {
          const currentMaterial = currentMatspec.admaterial[z];
          if (currentMaterial.id === materialId)
            return currentMaterial.status.code;
        }
    }
    return null;
  };

  setNewAssets = (admaterialId, newAssetIds, matspecid) => {
    //console.log(newAssetIds);
    //console.log(matspecid);
    //if(admaterialId < 0) admaterialId = null
    this.previewClick(
      true,
      admaterialId,
      matspecid,
      newAssetIds,
      true,
      this.getStatusCode(matspecid, admaterialId)
    );
    this.props.reviewButtonClicked(true);
  };
  onMatspecPanelChange = (key) => {
    const comp = this;
    const activeMatspecsNew = [];
    const lastInteracted = key.slice(-1)[0];

    // console.log(
    //   "lastInteracted ==>",
    //   key,
    //   lastInteracted,
    //   comp.props.matspecsBooking[lastInteracted]
    // );

    if (lastInteracted && comp.props.matspecsBooking[lastInteracted]) {
      // this.scrollView(comp.props.matspecsBooking[lastInteracted].id);
    }

    key && key.map((k) => activeMatspecsNew.push(`matspecPanel.${k}`));

    sessionStorage.setItem('activeMatspecs', activeMatspecsNew);

    setTimeout(function () {
      // const activePanels = document.getElementsByClassName(
      //   "ant-collapse-item-active"
      // );
      // console.log(activePanels);

      // const activeIds = new Array();
      // for (let i = 0; i < activePanels.length; i++)
      //   activeIds.push(activePanels[i].getAttribute("id"));
      // sessionStorage.setItem("activeMatspecs", activeIds);
      if (comp.props.loadConfig['web.uploadadmaterial.swap'])
        comp.setDraggableCreatives();
    }, 100);
  };

  previewClick = (
    editableView,
    admaterialId,
    matspecId,
    newAssetIds,
    productionad,
    status,
    showVisual
  ) => {
    const assetRequestStatuses = this.props.loadConfig.assetRequestStatuses;
    let showProductionAdButtons = false;
    if (assetRequestStatuses)
      for (let i = 0; i < assetRequestStatuses.length; i++) {
        const statusCode = assetRequestStatuses[i];
        if (status == statusCode && productionad) {
          productionad = true;
          showVisual = true;
          showProductionAdButtons = true;
          break;
        }
      }
    const values = [
      editableView,
      admaterialId,
      matspecId,
      newAssetIds,
      productionad,
      status,
      showVisual,
    ];
    //console.log(values);
    this.props.previewClick(
      editableView,
      admaterialId,
      matspecId,
      newAssetIds,
      productionad,
      status,
      showVisual,
      showProductionAdButtons
    );
  };

  swapButtonDown = (e) => {
    e.stopPropagation();
  };
  swapButtonUp = (e) => {
    e.stopPropagation();
  };

  handleMatSpecCheck = (id) => {
    let checkedids = this.props.checkedMatspecsArray ? [...this.props.checkedMatspecsArray] : [];

    const isChecked = checkedids.find((checkedId) => checkedId === id);
    if (isChecked) {
      checkedids = checkedids.filter(checkedId => checkedId !== id);
    } else {
      checkedids.push(id);
    }

    console.log("%c handleMatSpecCheck %o ", "background: green; color: white", checkedids);
    this.props.setCheckedMatspecsArray(checkedids);
  }

  handleMultiChecked = (e, type) => {
    const { checkedMatspecs, checkedAdMaterialsIds } = this.state;
    const id = e.target.id;
    const checked = e.target.checked;
    if (type === "group") {
        const sectionContainer = e.target.closest(".section-container");
        const matspecsIds = sectionContainer.querySelectorAll('[id*="matspecPanel."]');
        if (matspecsIds) {
            let checkedids = this.props.checkedMatspecsArray ? [...this.props.checkedMatspecsArray] : [];
            const sectionIsDeselected =
                this.state.selectedSections.find((selectedId) => selectedId === id) !== undefined;

            matspecsIds.forEach((matspecId) => {
                const [, stringId] = matspecId.getAttribute("id").split("matspecPanel.");
                const id = Number.parseInt(stringId);

                if (sectionIsDeselected) {
                    checkedids = [];
                } else {
                    checkedids.push(id);
                }

                // const isChecked = checkedids.find((checkedId) => checkedId === id);
                // if (isChecked) {
                //   checkedids = checkedids.filter(checkedId => checkedId !== id);
                // } else {
                //   checkedids.push(id);
                // }
            });
            if (!sectionIsDeselected) {
                checkedids = Array.from(new Set(checkedids));
            }
            console.log("%c handleMultiChecked %o ", "background: green; color: white", checkedids);
            this.props.setCheckedMatspecsArray(checkedids);
            if (sectionIsDeselected) {
                this.setState({
                    selectedSections: this.state.selectedSections.filter(
                        (selectedSectionId) => selectedSectionId !== id
                    ),
                });
            } else {
                this.setState({
                    selectedSections: [...this.state.selectedSections, id],
                });
            }
        }
    }
};


  nativeModalShow = async (admaterial, matspecId) => {
    this.setState({
      nativeModalVisible: true,
      nativeAdMaterial: admaterial,
    });

    const templates = await fetch(
      `${urlPath}/api/adservers/templates` + '?matspec=' + matspecId,
      // `${urlPath}/api/adservers/templates?matspec=${specId}`,
      {
        credentials: 'include',
        headers: getAuthHeader()
      }
    )
      .then((response) => response.json())
      .then((result) => result && result.templates)
      .catch((err) => console.log(err));

    this.setState({
      templates,
    });
  };

  handleNativeModalVisibleCancel = (e) => {
    this.setState({
      templates: false,
      nativeModalVisible: false,
    });
  };

  render() {
    if (!this.state.isInitialized || !this.props.matspecsBooking) return null;
    const comp = this;
    let {
      fieldTranslations,
      config,
      translations,
      campaignSectionsFinal,
      campaignSectionsStatuses,
      statuses,
      isNative,
      showExpandAll,
      defaultActiveKey,
      collapseAllOpen,
    } = this.state;

    let { matspecsBooking, internal, showKilled } = this.props;
    const { showArchived } = this.props;
    translations = this.props.translations || {};
    fieldTranslations = this.props.language || {};
    const Panel = Collapse.Panel;
    const ButtonGroup = Button.Group;
    const panelsArray = [];
    const sections = new Array();
    const newPanels = new Array();
    this.props.hidePreloadingMask();
    const matspecsBookingNotKilled = matspecsBooking.filter(
      (item) => item.status.code !== -9
    );
    const matspecsToHandle =
      internal && showKilled ? matspecsBooking : matspecsBookingNotKilled;
    for (let i = 0; i < matspecsToHandle.length; i++) {
      //if (i === matspecsBooking.length - 1) this.props.hidePreloadingMask();
      const currentMatspec = matspecsToHandle[i];
      const sortCreatives = this.props.loadConfig[
        'web.uploadadmaterial.sortcreatives'
      ];
      if (sortCreatives) {
        const sortFields = ['size', 'externalid', 'mastercompanion'];
        const dummyMaterial =
          currentMatspec.admaterial[currentMatspec.admaterial.length - 1];
        currentMatspec.admaterial = currentMatspec.admaterial.filter(
          (_) => !_.dummy
        );
        currentMatspec.admaterial = sortFields.map((field) =>
          currentMatspec.admaterial.sort((a, b) =>
            a[field] > b[field] ? 1 : -1
          )
        );
        currentMatspec.admaterial.push(dummyMaterial);
      }
      let creativesToReview = 0;
      const columns = [];
      const tableFields =
        config && config.tableFields
          ? currentMatspec.printed
            ? config.tableFieldsPrint
              ? config.tableFieldsPrint
              : config.tableFields
            : config.tableFields
          : null;
      if (!tableFields.includes('native') && !currentMatspec.printed) {
        tableFields.splice(12, 0, 'native');
      }
      if (config && tableFields)
        for (let i = 0; i < tableFields.length; i++) {
          const field = tableFields[i];
          if (!field) continue;
          /*if(!draggableRowItemPlaced){
                        draggableRowItemPlaced = true;
                        columns.push({
                            dataIndex: Math.random(),
                            render: (text, record) => (
                                <Button className="swap-creative-button"
                                        type="secondary"
                                        size="small"
                                        icon="swap"
                                        draggable="true"
                                        onMouseDown={(e) => this.swapButtonDown(e)}
                                        onMouseUp={(e) => this.swapButtonUp(e)}
                                />
                            )});
                    }*/
          // if (field === 'multiupload') {
          //   columns.push({
          //     title: '',
          //     dataIndex: Math.random(),
          //     render: (text, record) => (
          //       <div className="ix-field-value">
          //         <Checkbox
          //           disabled={this.props.multiUploadChecked}
          //           // disabled={record.id < 0}
          //           data-id={record.materialSpecificationId}
          //           data-admat-id={record.id}
          //           className="multiupload-checkbox"
          //           checked={
          //             (this.state.checkedMatspecs.filter(
          //               (_) => _ === record.materialSpecificationId
          //             ).length !== 0 || this.props.multiUploadChecked) && record.id > 0
          //           }
          //           checked={(this.props.multiUploadChecked && record.id > 0) || this.state.checkedAdMaterialsIds.find((id) => id === record.id) !== undefined}
          //           onChange={(e) =>
          //             this.handleMultiChecked(
          //               e,
          //               'matspec',
          //               record.materialSpecificationId
          //             )
          //           }
          //         // onChange={(e) => {
          //         //   const { checked } = e.target;
          //         //   if (checked) {
          //         //     this.setState({ checkedAdMaterialsIds: [...this.state.checkedAdMaterialsIds, record.id] })
          //         //   } else {
          //         //     this.setState({ checkedAdMaterialsIds: this.state.checkedAdMaterialsIds.filter((id) => id !== record.id) })
          //         //   }
          //         // }}
          //         />
          //       </div>
          //     ),
          //   });
          // }
          if (field === 'preview') {
            columns.push({
              title: translations[field] ? (
                <span
                  data-headerfield={field}
                  className="ix-field-columnheader"
                >
                  {translations[field]}
                </span>
              ) : (
                  <span
                    data-headerfield={field}
                    className="ix-field-columnheader"
                  >
                    {field}
                  </span>
                ),
              dataIndex: field,
              render: (text, record) => (
                <div className="ad-thumbnail-container">
                  {record.format && record.format === 'mp3' ? (
                    <img
                      id={'adThumbnail.' + record.id}
                      className={
                        record.original &&
                          record.original.url &&
                          record.original.url.endsWith('.svg')
                          ? 'ad-thumbnail processing-image'
                          : 'ad-thumbnail'
                      }
                      alt="preview"
                      src={Mp3Icon}
                      onClick={() => {
                        this.props.reviewButtonClicked(false);
                        this.previewClick(
                          true,
                          record.id,
                          record.materialSpecificationId,
                          '[]',
                          record.productionad,
                          record.status.code
                        );
                      }}
                    />
                  ) : (
                      <img
                        id={'adThumbnail.' + record.id}
                        className={
                          record.original &&
                            record.original.url &&
                            record.original.url.endsWith('.svg')
                            ? 'ad-thumbnail processing-image'
                            : 'ad-thumbnail'
                        }
                        alt="preview"
                        src={
                          record.preview
                            ? imageUrlPath + record.preview.url
                            : record.bigpreview
                              ? imageUrlPath + record.bigpreview.url
                              : record.original && record.original.length > 0
                                ? record.original[0].url &&
                                  !record.original[0].url.endsWith('html')
                                  ? imageUrlPath + record.original[0].url
                                  : record.status.code === 3
                                    ? Spinner
                                    : Placeholder
                                : this.props.internal
                                  ? EditIcon
                                  : ''
                        }
                        onClick={() => {
                          this.props.reviewButtonClicked(false);
                          this.previewClick(
                            true,
                            record.id,
                            record.materialSpecificationId,
                            '[]',
                            record.productionad,
                            record.status.code
                          );
                        }}
                      />
                    )}
                </div>
              ),
            });
          } else if (field === 'AdMaterial.externalid') {
            columns.push({
              title: fieldTranslations ? (
                <span
                  data-headerfield={field}
                  className="ix-field-columnheader"
                >
                  {fieldTranslations['Job.admaterial:' + field]}
                </span>
              ) : (
                  <span
                    data-headerfield={field}
                    className="ix-field-columnheader"
                  >
                    {field}
                  </span>
                ),
              dataIndex: field,
              render: (text, record) => (
                <span className="ix-field-value">
                  {!(!this.props.loadConfig['web.campaign.showclientviewdetailsshortcut'] && !this.props.internal && record.matspecProps.showNative) ? (
                    <a
                      href="#"
                      onClick={() => {
                        this.props.reviewButtonClicked(false);
                        this.previewClick(
                          true,
                          record.id,
                          record.materialSpecificationId,
                          '[]',
                          record.productionad,
                          record.status.code
                        );
                      }}
                    >
                      {record.externalid}
                    </a>
                  ) : record.externalid}
                </span>
              ),
            });
          } else if (field === 'AdMaterial.status') {
            columns.push({
              title: fieldTranslations ? (
                <span
                  data-headerfield={field}
                  className="ix-field-columnheader"
                >
                  {fieldTranslations['Job.admaterial:' + field]}
                </span>
              ) : (
                  <span
                    data-headerfield={field}
                    className="ix-field-columnheader"
                  >
                    {field}
                  </span>
                ),
              dataIndex: field,
              render: (text, record) => {
                return (
                  <Tooltip
                    title={
                      record.status &&
                        record.status.code &&
                        statuses &&
                        statuses.data[record.status.code]
                        ? statuses.data[record.status.code].text
                        : record.status
                          ? record.status.code
                          : '-'
                    }
                  >
                    <span
                      className="ix-field-value AdMaterial_status"
                      title={record.status ? record.status.code : ''}
                      style={
                        record.status && record.status.color
                          ? {
                            border: '1px solid ' + record.status.color,
                            background: record.status.color + '50',
                          }
                          : null
                      }
                    >
                      {record.status &&
                        record.status.code &&
                        statuses &&
                        statuses.data[record.status.code]
                        ? statuses.data[record.status.code].text
                        : record.status
                          ? record.status.code
                          : '-'}
                    </span>
                  </Tooltip>
                );
              },
            });
          } else if (field === 'AdMaterial.pixeltracker') {
            let field_ = field.replace('AdMaterial.', '');
            columns.push({
              title: fieldTranslations ? (
                <span
                  data-headerfield={field}
                  className="ix-field-columnheader"
                >
                  {fieldTranslations['Job.admaterial:' + field]}
                </span>
              ) : (
                  <span
                    data-headerfield={field}
                    className="ix-field-columnheader"
                  >
                    {field}
                  </span>
                ),
              dataIndex: field_,
              key: field_,
              render: (text, record) => (
                <div
                  data-field={field_}
                  className="ix-field-value ix-field-value-url"
                  style={{ overflow: 'unset' }}
                >
                  <Icon
                    type="edit"
                    className={
                      record.digitalmatspec ? 'table-input-icon' : 'd-none'
                    }
                  />
                  <Input
                    addonAfter={
                      <span>
                        <Tooltip
                          title={
                            translations
                              ? translations.copyToClipboard
                              : 'Copy to clipboard'
                          }
                        >
                          <Icon
                            type="copy"
                            onClick={(e) => copyToClipboard(e)}
                          />
                        </Tooltip>
                        <Tooltip
                          title={
                            translations ? translations.openLink : 'Open link'
                          }
                        >
                          <Icon
                            type="link"
                            onClick={(e) => {
                              window.open(
                                e.target
                                  .closest('.ix-field-value-url')
                                  .querySelectorAll('input')[0].value &&
                                  e.target
                                    .closest('.ix-field-value-url')
                                    .querySelectorAll('input')[0].value.length >
                                  0
                                  ? e.target
                                    .closest('.ix-field-value-url')
                                    .querySelectorAll('input')[0].value
                                  : record.userurls[0],
                                '_blank'
                              );
                            }}
                          />
                        </Tooltip>
                      </span>
                    }
                    placeholder={record.pixeltracker}
                    className={record.digitalmatspec ? 'table-input' : 'd-none'}
                    size="small"
                    onChange={this.handleValueChange.bind(
                      this,
                      record.id,
                      'pixeltracker',
                      record.materialSpecificationId
                    )}
                  />
                </div>
              ),
            });
          } else if (field === 'AdMaterial.description') {
            let field_ = field.replace('AdMaterial.', '');
            columns.push({
              title: fieldTranslations ? (
                <span
                  data-headerfield={field}
                  className="ix-field-columnheader"
                >
                  {fieldTranslations['Job.admaterial:' + field]}
                </span>
              ) : (
                  <span
                    data-headerfield={field}
                    className="ix-field-columnheader"
                  >
                    {field_}
                  </span>
                ),
              dataIndex: field_,
              key: field_,
              render: (text, record) => (
                <div data-field={field_} className="ix-field-value">
                  <Icon
                    type="edit"
                    className={
                      record.digitalmatspec ? 'table-input-icon' : 'd-none'
                    }
                  />
                  <Input
                    placeholder={record.description}
                    className={
                      record.description
                        ? 'table-input table-input-filled'
                        : 'table-input'
                    }
                    size="small"
                    onChange={this.handleValueChange.bind(
                      this,
                      record.id,
                      'description',
                      record.materialSpecificationId
                    )}
                  />
                </div>
              ),
            });
          } else if (field === 'AdMaterial.userurls') {
            let field_ = field.replace('AdMaterial.', '');
            columns.push({
              title: fieldTranslations ? (
                <span
                  data-headerfield={field}
                  className="ix-field-columnheader"
                >
                  {fieldTranslations['Job.admaterial:' + field]}
                </span>
              ) : (
                  <span data-headerfield={field}>{field_}</span>
                ),
              dataIndex: field_,
              key: field_,
              render: (text, record) => (
                <div
                  data-field={field_}
                  className="ix-field-value ix-field-value-url"
                  style={{ overflow: 'unset' }}
                >
                  <Icon
                    type="edit"
                    className={
                      record.digitalmatspec ? 'table-input-icon' : 'd-none'
                    }
                  />
                  <Input
                    addonAfter={
                      <span>
                        <Tooltip
                          title={
                            translations
                              ? translations.copyToClipboard
                              : 'Copy to clipboard'
                          }
                        >
                          <Icon
                            type="copy"
                            onClick={(e) => copyToClipboard(e)}
                          />
                        </Tooltip>
                        <Tooltip
                          title={
                            translations ? translations.openLink : 'Open link'
                          }
                        >
                          <Icon
                            type="link"
                            onClick={(e) => {
                              //console.log(e.target.value);
                              window.open(
                                e.target
                                  .closest('.ix-field-value-url')
                                  .querySelectorAll('input')[0].value &&
                                  e.target
                                    .closest('.ix-field-value-url')
                                    .querySelectorAll('input')[0].value.length >
                                  0
                                  ? e.target
                                    .closest('.ix-field-value-url')
                                    .querySelectorAll('input')[0].value
                                  : record.userurls[0],
                                '_blank'
                              );
                            }}
                          />
                        </Tooltip>
                      </span>
                    }
                    placeholder={record.userurls ? record.userurls[0] : null}
                    className="table-input"
                    size="small"
                    type="url"
                    onChange={this.handleValueChange.bind(
                      this,
                      record.id,
                      'userurl',
                      record.materialSpecificationId
                    )}
                  />
                </div>
              ),
            });
          } else if (field === 'AdMaterial.adserverurl') {
            let field_ = field.replace('AdMaterial.', '');
            columns.push({
              title: '',
              dataIndex: field_,
              key: field_,
              render: (text, record) => (
                <div
                  data-field={field_}
                  className={
                    record.adserverurl
                      ? 'ix-field-value text-center'
                      : 'v-hidden'
                  }
                >
                  <Tooltip
                    title={
                      translations.openInServer
                        ? translations.openInServer
                        : 'Open in Server'
                    }
                    mouseEnterDelay={0.5}
                  >
                    <a href={record.adserverurl} target="_blank">
                      <img
                        src={
                          currentMatspec.adserverurl &&
                            currentMatspec.adserverurl.includes('xandr.com')
                            ? nexusLogo
                            : gam
                        }
                        alt="gam"
                        style={{ width: '25px' }}
                      />
                    </a>
                  </Tooltip>
                </div>
              ),
            });
          } else if (field === 'AdMaterial.validation') {
            let field_ = field.replace('AdMaterial.', '');
            columns.push({
              title: (
                <span data-headerfield={field}>{translations.validation}</span>
              ),
              dataIndex: field_,
              key: field_,
              render: (text, record) => (
                <div
                  data-field={field_}
                  className={
                    record.status.code === 522 ||
                      record.status.code === 3 ||
                      record.id < 0 ||
                      !record.original
                      ? 'd-none'
                      : 'ix-field-value'
                  }
                >
                  {record.haserrors && record.haserrors.length > 0 ? (
                    <span className="tomato">
                      {translations.validationError}
                    </span>
                  ) : (
                      <span className="nephritis">
                        {translations.validationOk}
                      </span>
                    )}
                </div>
              ),
            });
          } else if (field === 'AdMaterial.url') {
            let field_ = field.replace('AdMaterial.', '');
            columns.push({
              title: <span data-headerfield={field}>{translations.url}</span>,
              dataIndex: field_,
              key: field_,
              render: (text, record) => (
                <div data-field={field_} className="ix-field-value">
                  {!record.userurls || record.userurls.length < 1 ? (
                    <span className="warning">
                      {translations.noUrlProvided}
                    </span>
                  ) : (
                      <span> {translations.urlProvided}</span>
                    )}
                </div>
              ),
            });
          } else if (field === 'actions') {
            columns.push({
              dataIndex: field,
              render: (text, record) => (
                <div className="text-right actions-cell">
                  <ButtonGroup className="actions-buttongroup">
                    {!(!this.props.loadConfig['web.campaign.showclientviewdetailsshortcut'] && !this.props.internal && record.matspecProps.showNative) && (
                      <Tooltip
                        title={translations ? translations.view : 'View'}
                        mouseEnterDelay={0.5}
                      >
                        <Button
                          onClick={() => {
                            this.props.reviewButtonClicked(false);
                            this.previewClick(
                              this.props.internal ? true : false,
                              record.id,
                              record.materialSpecificationId,
                              '[]',
                              record.productionad,
                              record.status.code
                            );
                          }}
                          size="small"
                          type="default"
                          style={{ border: 'none' }}
                        >
                          <FontAwesomeIcon icon="eye" />
                        </Button>
                      </Tooltip>
                    )}
                    <Tooltip
                      title={translations ? translations.download : 'Download'}
                      mouseEnterDelay={0.5}
                    >
                      {this.props.loadConfig[
                        'web.campaign.downloadnormalized'
                      ] ? (
                          record.processed ? (
                            <a
                              href={
                                record && record.processed
                                  ? record.processed.url
                                  : '#'
                              }
                              target="_blank"
                            >
                              <Icon type="download" />
                            </a>
                          ) : null
                        ) : (
                          <a
                            href="#"
                            id={'downloadElem.' + record.id}
                            className={
                              'downloadElem' +
                              (record.actions && record.actions.DOWNLOAD
                                ? ''
                                : ' d-none')
                            }
                            onClick={this.downloadAd.bind(this, record.id)}
                            download={
                              record.inputfilename
                                ? record.inputfilename.substr(
                                  0,
                                  record.inputfilename.indexOf('.')
                                )
                                : record.materialSpecificationName
                            }
                          >
                            <Icon type="download" />
                          </a>
                        )}
                    </Tooltip>
                    {record.SOURCEFILE && (
                      <Tooltip
                        title={
                          translations ? translations.download : 'Download'
                        }
                        mouseEnterDelay={0.5}
                      >
                        <a
                          href={record.SOURCEFILE.url}
                          target="_blank"
                          className="downloadElem"
                        >
                          <Icon
                            type={
                              record.SOURCEFILE.url.endsWith('.xls') ||
                                record.SOURCEFILE.url.endsWith('.xlsx')
                                ? 'file-excel'
                                : record.SOURCEFILE.url.endsWith('.doc') ||
                                  record.SOURCEFILE.url.endsWith('.docx')
                                  ? 'file-word'
                                  : record.SOURCEFILE.url.endsWith('.txt')
                                    ? 'file-text'
                                    : 'file'
                            }
                          />
                        </a>
                      </Tooltip>
                    )}
                    <Tooltip
                      title={translations ? translations.delete : 'Delete'}
                      mouseEnterDelay={0.5}
                    >
                      <Button
                        onClick={() => {
                          this.deleteMaterialConfirmation(
                            record.id,
                            record.materialSpecificationId,
                            record.status.code,
                            record.original ? record.original.url : '',
                            record.initialStatus,
                            record.matfilecount,
                            currentMatspec
                          )
                        }

                        }
                        className={
                          'tomato deleteCreativeElem' +
                          (record.actions && record.actions.DELETE
                            ? ''
                            : ' d-none')
                        }
                        size="small"
                        type="default"
                        style={{ border: 'none' }}
                      >
                        <FontAwesomeIcon icon="trash" />
                      </Button>
                    </Tooltip>
                    {false &&
                      record.actions &&
                      record.actions.DELIVER &&
                      record.digitalmatspec && (
                        <Tooltip
                          data-translationkey="deliver"
                          title={translations.deliver}
                          mouseEnterDelay={0.5}
                        >
                          <Button
                            id={'deliverButton.' + record.id}
                            className="approve-material-button deliver-button"
                            onClick={() => {
                              this.checkMaterialUrls(record, 'deliver');
                            }}
                            size="small"
                            type="default"
                            style={{
                              border: 'none',
                            }}
                          >
                            <Icon
                              type="rocket"
                              style={{
                                color: '#3498DB',
                              }}
                            />
                            <FontAwesomeIcon
                              className="approve-progress-icon"
                              icon="spinner"
                              spin
                            />
                          </Button>
                        </Tooltip>
                      )}
                    {record.actions && record.actions.APPROVE && (
                      <Tooltip
                        data-translationkey="approve"
                        title={translations.approve}
                        mouseEnterDelay={0.5}
                      >
                        <Button
                          id={'approveButton.' + record.id}
                          className="approve-material-button"
                          onClick={() => {
                            this.checkMaterialUrls(record, 'approve');
                          }}
                          size="small"
                          type="default"
                          style={{
                            border: 'none',
                          }}
                        >
                          <FontAwesomeIcon
                            className="approve-icon"
                            icon="check-circle"
                          />
                          <FontAwesomeIcon
                            className="approve-progress-icon"
                            icon="spinner"
                            spin
                          />
                        </Button>
                      </Tooltip>
                    )}
                  </ButtonGroup>
                  <span
                    data-id={record.id}
                    id={'dropzone-AdMaterial.' + record.id}
                    className="fileupload-container valid-false review-false action-buttons-group"
                  >
                    {setTimeout(function () {
                      const dropzone = document.getElementById(
                        'dropzone-AdMaterial.' + record.id
                      );
                      if (record.id <= 0 && dropzone) {
                        dropzone.classList.remove('valid-false');
                        dropzone.classList.add('valid-true', 'review-false');
                      }
                      if (
                        record.status &&
                        record.status.code &&
                        record.actions &&
                        dropzone
                      ) {
                        if (
                          /* devMode || */
                          (record.actions.UPLOAD_ADMATERIAL &&
                            (comp.props.internal ||
                              !comp.props.loadConfig[
                              'web.uploadadmaterial.customer.bigdropzone'
                              ]))
                        ) {
                          dropzone.classList.remove('valid-false');
                          dropzone.classList.add('valid-true');
                        } else {
                          dropzone.classList.remove('valid-true');
                          dropzone.classList.add('valid-false');
                        }
                        if (record.actions.REVIEW && !record.matspecProps.showNative) {
                          dropzone.classList.remove('review-false');
                          dropzone.classList.add('review-true');
                        } else {
                          dropzone.classList.remove('review-true');
                          dropzone.classList.add('review-false');
                        }
                        if (
                          record.actions.REVIEW_ASSET &&
                          !record.actions.REVIEW
                        ) {
                          dropzone.classList.remove('asset-false');
                          dropzone.classList.add('asset-true');
                        } else {
                          dropzone.classList.remove('asset-true');
                          dropzone.classList.add('asset-false');
                        }
                        if (!record.actions.UPLOAD_ASSET) {
                          dropzone.classList.add('asset-upload-false');
                        } else {
                          dropzone.classList.add('asset-upload-true');
                        }
                      }
                    }, 100)}
                    <div
                      className={
                        this.props.translations &&
                          this.props.translations.partyTagSmallDropzoneLabel &&
                          this.props.translations.partyTagSmallDropzoneLabel
                            .length > 0
                          ? 'upload-form-container upload-form-container__partylabel'
                          : 'upload-form-container'
                      }
                    >
                      <div className="admaterial-action-buttons">
                        {(this.props.internal ||
                          (!this.props.internal &&
                            !this.props.loadConfig[
                            'web.uploadadmaterial.customer.bigdropzone'
                            ]) ||
                          (!this.props.internal &&
                            !record.productionad &&
                            this.props.loadConfig[
                            'web.uploadadmaterial.customer.bigdropzone'
                            ] &&
                            (record.original &&
                              record.original[0] &&
                              record.original[0].url))) && (
                            <span>
                              <Button
                                id={'review-asset-btn.' + record.id}
                                className="review-creative-button review-asset-button"
                                type="primary"
                                size="small"
                                onClick={() =>
                                  this.previewClick(
                                    true,
                                    record.id ? record.id : null,
                                    record.materialSpecificationId,
                                    '[]',
                                    true,
                                    record.status.code
                                  )
                                }
                                data-translationkey="reviewAsset"
                              >
                                {translations.reviewAsset}
                              </Button>
                              <Button
                                id={'review-creative-btn.' + record.id}
                                className="review-creative review-creative-button"
                                type="primary"
                                size="small"
                                onClick={() => {
                                  this.props.reviewButtonClicked(true);
                                  this.previewClick(
                                    true,
                                    record.id,
                                    record.materialSpecificationId,
                                    '[]',
                                    record.productionad,
                                    record.status.code
                                  );
                                }}
                                data-translationkey="reviewCreative"
                              >
                                {translations.reviewCreative}
                              </Button>
                              {(!record.matspecProps.showNative || this.props.internal) && (
                                <FileUpload
                                  admaterialUploaded={this.admaterialUploaded}
                                  admaterialUploading={this.admaterialUploading}
                                  filePlaceholder={translations.dropFiles}
                                  language={fieldTranslations}
                                  loadConfig={this.props.loadConfig}
                                  materialSpecificationId={
                                    record.materialSpecificationId
                                      ? record.materialSpecificationId
                                      : null
                                  }
                                  printAd={
                                    record.digitalmatspec ? 'DIGITAL' : 'PRINTED'
                                  }
                                  specId={record.id}
                                  submitting={this.props.submitting}
                                  translations={translations}
                                />
                              )}

                              {((comp.props.internal && record.digitalmatspec) ||
                                (record.digitalmatspec &&
                                  record.status.code !== 3 &&
                                  record.status.code !== 513 &&
                                  record.status.code !== 521 &&
                                  record.status.code !== 518 &&
                                  record.status.code !== 519)) && (
                                  <Fragment>
                                    {(!record.matspecProps.showNative || this.props.internal) && (
                                      <PartyTagModal
                                        saveFields={this.props.saveFields}
                                        fieldsToSave={this.props.fieldsToSave}
                                        id={record.id}
                                        inputfilename={record.inputfilename}
                                        pixeltracker={
                                          record.pixeltracker
                                            ? record.pixeltracker
                                            : ''
                                        }
                                        description={
                                          record.description
                                            ? record.description
                                            : ''
                                        }
                                        sgcode={record.sgcode ? record.sgcode : ''}
                                        userurls={
                                          record.userurls ? record.userurls : []
                                        }
                                        internal={this.props.internal}
                                        userurl={
                                          record.userurls && record.userurls[0]
                                            ? record.userurls[0]
                                            : ''
                                        }
                                        handlePartyTag={this.handlePartyTag}
                                        loadConfig={this.props.loadConfig}
                                        materialSpecificationId={
                                          record.materialSpecificationId
                                        }
                                        placeholder={
                                          translations
                                            ? translations.partytag
                                            : 'script tag'
                                        }
                                        translations={
                                          translations
                                            ? translations
                                            : this.props.translations
                                        }
                                        updateBooking={this.updateBooking}
                                      />
                                    )}

                                  </Fragment>
                                )}
                              <AssetUpload
                                admaterialUploaded={this.admaterialUploaded}
                                admaterialUploading={this.admaterialUploading}
                                dropAssets={translations.dropAssets}
                                language={fieldTranslations}
                                materialSpecificationId={
                                  record.materialSpecificationId
                                    ? record.materialSpecificationId
                                    : null
                                }
                                printAd={
                                  record.digitalmatspec ? 'DIGITAL' : 'PRINTED'
                                }
                                setNewAssets={this.setNewAssets}
                                specId={record.id}
                                status={record.status.code}
                                submitting={this.props.submitting}
                                translations={translations}
                                loadConfig={this.props.loadConfig}
                                unsubmittedChanges={this.props.unsubmittedChanges}
                              />
                            </span>
                          )}

                        {/*devMode ||*/ !this.props.internal &&
                          this.props.loadConfig[
                          'web.uploadadmaterial.customer.bigdropzone'
                          ] &&
                          !record.matspecProps.showNative &&
                          record.actions &&
                          record.actions.UPLOAD_ADMATERIAL &&
                          !record.productionad && (
                            <DropArea
                              saveFields={this.props.saveFields}
                              record={record}
                              admaterialUploaded={this.admaterialUploaded}
                              admaterialUploading={this.admaterialUploading}
                              materialSpecificationId={
                                record.materialSpecificationId
                                  ? record.materialSpecificationId
                                  : null
                              }
                              printAd={
                                record.digitalmatspec ? 'DIGITAL' : 'PRINTED'
                              }
                              specId={record.id}
                              submitting={this.props.submitting}
                              translations={translations}
                              internal={this.props.internal}
                              handlePartyTag={this.handlePartyTag}
                              loadConfig={this.props.loadConfig}
                              placeholder={translations.partytag}
                              updateBooking={this.updateBooking}
                            />
                          )}
                        {/*devMode ||*/ !this.props.internal &&
                          this.props.loadConfig[
                          'web.uploadadmaterial.customer.bigdropzone'
                          ] &&
                          !record.matspecProps.showNative &&
                          record.productionad && (
                            <span className="big-assetupload-container">
                              <Button
                                id={'review-asset-btn.' + record.id}
                                className="review-creative-button review-asset-button"
                                type="primary"
                                size="small"
                                onClick={() =>
                                  this.previewClick(
                                    true,
                                    record.id ? record.id : null,
                                    record.materialSpecificationId,
                                    '[]',
                                    true,
                                    record.status.code
                                  )
                                }
                                data-translationkey="reviewAsset"
                              >
                                {translations.reviewAsset}
                              </Button>

                              <AssetUploadBig
                                admaterialUploaded={this.admaterialUploaded}
                                admaterialUploading={this.admaterialUploading}
                                dropAssets={translations.dropAssets}
                                language={fieldTranslations}
                                materialSpecificationId={
                                  record.materialSpecificationId
                                    ? record.materialSpecificationId
                                    : null
                                }
                                printAd={
                                  record.digitalmatspec ? 'DIGITAL' : 'PRINTED'
                                }
                                setNewAssets={this.setNewAssets}
                                specId={record.id}
                                status={record.status.code}
                                submitting={this.props.submitting}
                                translations={translations}
                                loadConfig={this.props.loadConfig}
                                unsubmittedChanges={
                                  this.props.unsubmittedChanges
                                }
                              />
                            </span>
                          )}
                        {((this.props.loadConfig &&
                          this.props.loadConfig[
                          'web.campaign.nativetemplate'
                          ]) &&
                          ((this.props.internal && record.matspecProps.creativetype && record.matspecProps.creativetype.toLowerCase() !== "print") ||
                            (!this.props.internal && record.matspecProps.showNative))) && (
                            <NativeTemplatesComponent
                              state={this.state}
                              props={this.props}
                              record={record}
                              native={record.matspecProps.showNative}
                              internal={this.props.internal}
                              nativeModalShow={(id, matspecId) =>
                                this.nativeModalShow(id, matspecId)
                              }
                              handleVisisbleCancel={
                                this.handleNativeModalVisibleCancel
                              }
                              specId={this.props.specId}
                              childConfig={{
                                translations,
                                record,
                                fieldTranslations,
                                currentMatspec,
                              }}
                            />
                          )}

                      </div>
                    </div>
                  </span>
                </div>
              ),
            });
          } /*else if(field === 'dropzone' && (devMode || !this.state.internal) && this.props.loadConfig['web.uploadadmaterial.customer.bigdropzone']) {
						columns.push({
							dataIndex: field,
							render: (text, record) => (
                                        <DropArea
                                            record={record}
                                            admaterialUploaded={this.admaterialUploaded}
                                            admaterialUploading={this.admaterialUploading}
                                            materialSpecificationId={record.materialSpecificationId? record.materialSpecificationId: null}
                                            printAd={record.digitalmatspec? 'DIGITAL': 'PRINTED'}
                                            specId={record.id}
                                            submitting={this.props.submitting}
                                            translations={translations}
                                            internal={this.state.internal}
                                            handlePartyTag={this.handlePartyTag}
                                            loadConfig={this.props.loadConfig}
                                            placeholder={translations.partytag}
                                        />
                                )
                        })
                    }*/ else {
            let field_;
            let string;
            if (field.includes('MaterialSpecification')) {
              field_ = field.replace('MaterialSpecification.', '');
              string = 'Job.matspec:' + field;
              field_ = 'matspecProps.' + field_;
              /*if (field.includes('size')) {
                field_ = "materialSpecificationSize"
              }
              if (field.includes('modulesize')) {
                field_ = "materialSpecificationModulesize"
              }
              if (field.includes('alltitles')) {
                field_ = "alltitles"
              }*/
            } else if (field.includes('AdMaterial')) {
              field_ = field.replace('AdMaterial.', '');
              string = 'Job.admaterial:' + field;
            } else if (field.includes('Ad')) {
              field_ = field.replace('Ad.', '');
              string = 'Job.ad:' + field;
            } else if (field.includes('Insertion.')) {
              field_ = field.replace('Insertion.', 'insertion');
              string = 'Job.insertion:' + field;
            } else {
              field_ = field;
              string = field;
            }
            /*eslint no-eval: "off"*/
            columns.push({
              title: fieldTranslations ? (
                <span
                  data-headerfield={field}
                  className="ix-field-columnheader"
                >
                  {fieldTranslations[string]}
                </span>
              ) : (
                  field_
                ),
              dataIndex: field_ + Math.random(),
              render: (text, record) => (
                <div
                  data-field={field_.toLowerCase()}
                  className="ix-field-value"
                >
                  {typeof eval('record.' + field_) === 'boolean' ? (
                    eval('record.' + field_) ? (
                      <Icon type="check-circle" />
                    ) : (
                        ''
                      )
                  ) : (
                      <Tooltip
                        mouseEnterDelay={0.5}
                        title={eval('record.' + field_)}
                      >
                        {typeof eval('record.' + field_) === 'string' ? (
                          <Interweave content={eval('record.' + field_)} />
                        ) : eval('record.' + field_) === null ||
                          eval('record.' + field_) === -1 ? (
                              '-'
                            ) : (
                              eval('record.' + field_)
                            )}
                      </Tooltip>
                    )}
                </div>
              ),
            });
          }
        }
      let creativesLength = currentMatspec.admaterial.length;
      for (let j = 0; j < currentMatspec.admaterial.length; j++) {
        let adm = currentMatspec.admaterial[j];
        if (adm.dummy) creativesLength = creativesLength - 1;
        if (!adm) {
          console.error('admaterial ' + j + ' is undefined', currentMatspec);
          continue;
        }
        if (
          (adm.actions && adm.actions.APPROVE) ||
          adm.actions['APPROVE-NOT'] === 'gam destination'
        ) {
          currentMatspec.approve = true;
        }

        if (adm.actions && (adm.actions.DELIVER || (adm.actions["DELIVER-NOT"] && adm.actions["DELIVER-NOT"].toLowerCase().includes('gam'))) && !currentMatspec.printed) {
          currentMatspec.showDeliverButton = true;
        }
        adm.digitalmatspec = !currentMatspec.printed;
        adm.materialSpecificationId = currentMatspec.id;
        adm.productionad = currentMatspec.productionad;
        //adm.UPLOAD_ADMATERIAL = currentMatspec.actions.UPLOAD_ADMATERIAL;
        //adm.UPLOAD_ASSET = currentMatspec.actions.UPLOAD_ASSET;
        //adm.REVIEW = currentMatspec.actions.REVIEW;
        adm.materialSpecificationName = currentMatspec.name;
        adm.materialSpecificationSize = currentMatspec.size;
        adm.matspecAdServerUrl = currentMatspec.adserverurl;
        adm.materialSpecificationModulesize = currentMatspec.modulesize;
        //adm.alltitles = currentMatspec.alltitles;
        adm.modulewidth = currentMatspec.modulewidth;
        adm.moduleheight = currentMatspec.moduleheight;
        adm.firstinsertiondate = currentMatspec.firstinsertiondate;
        adm.deadline = currentMatspec.deadline;
        adm.insertiondatescount = currentMatspec.insertiondatescount;
        adm.designtype = currentMatspec.designtype;
        adm.dummyCreativeTypePrinted = currentMatspec.printed;

        /* Including insertion in adm */
        if (currentMatspec.insertions && currentMatspec.insertions[0]) {
          for (let [key, value] of Object.entries(
            currentMatspec.insertions[0]
          )) {
            if (!Array.isArray(value)) {
              adm['insertion' + key] = value;
            }
          }
          if (currentMatspec.insertions[0]) {
            if (currentMatspec.insertions[0].title)
              adm.insertiontitle = currentMatspec.insertions[0].title.name;
            if (currentMatspec.insertions[0].edition)
              adm.insertionedition = currentMatspec.insertions[0].edition.name;
            if (currentMatspec.insertions[0].placement)
              adm.insertionplacement =
                currentMatspec.insertions[0].placement.name;
          }
        }
        const statusCode = adm.status.code;
        //let materialSpecFields = null;
        //(this.state.matspecsBooking).map(item => console.log(item))
        //console.log(materialSpecFields)
        adm.matspecProps = {};
        for (let [key, value] of Object.entries(currentMatspec)) {
          if (!Array.isArray(value)) {
            adm.matspecProps[key] = value;
          }
        }
        if (!adm.initialStatus)
          adm.initialStatus = adm.id < 0 ? adm.status.code : null;

        if (
          !adm.dummy &&
          statusCode &&
          (statusCode !== 510 && statusCode !== 100005 && statusCode !== 519)
        )
          creativesToReview++;
      }
      let currentMatspecCreativetype = currentMatspec.creativetype
        ? currentMatspec.creativetype.toLowerCase()
        : 'null';

      if (config && currentMatspec)
        panelsArray.push(
          <Panel
            className={
              currentMatspec.archived
                ? 'creative-type creative-type-' +
                currentMatspecCreativetype +
                ' creative-archived-true ' +
                showArchived
                : 'creative-type creative-type-' +
                currentMatspecCreativetype +
                ' creative-archived-false ' +
                showArchived
            }
            data-archived="true"
            id={'matspecPanel.' + currentMatspec.id}
            header={
              <MatspecHeader
                randomNumber={this.state.randomNumber}
                handleMatSpecCheck={this.handleMatSpecCheck}
                currentTabKey={this.props.currentTabKey}
                multiUploadChecked={this.props.multiUploadChecked}
                statuses={statuses}
                config={config}
                translations={translations}
                currentMatspec={currentMatspec}
                creativesToReview={creativesToReview}
                creativesLength={creativesLength}
                checkedMatspecsArray={this.props.checkedMatspecsArray}
              />
            }
            key={currentMatspec.id}
          >
            <span className="matspec-header-btn-container">
              {currentMatspec.admaterial[0] &&
                currentMatspec.admaterial[0].actions &&
                currentMatspec.admaterial[0].actions.DOWNLOAD && (
                  <a
                    data-translationkey="download"
                    href="#"
                    id={'downloadMatspec.' + currentMatspec.id}
                    matspec-id={currentMatspec.id}
                    className={'matspec-header-btn download-matspec'}
                    onClick={(e) => this.downloadMatspec(e, currentMatspec.id)}
                  >
                    {translations.download}
                  </a>
                )}
              <a
                id={'addCreative.' + currentMatspec.id}
                data-translationkey="addCreative"
                href="#"
                matspec-id={currentMatspec.id}
                className={
                  currentMatspec.printed
                    ? 'd-none'
                    : 'matspec-header-btn add-creative-btn'
                }
                onClick={this.addCreative}
              >
                {translations.addCreative}
              </a>
              <Button
                loading={this.state.matspecIsDelivering}
                matspec-id={currentMatspec.id}
                id={'matspecDeliverButton.' + currentMatspec.id}
                className={
                  !currentMatspec.showDeliverButton
                    ? 'd-none'
                    : 'matspec-header-btn btn-success matspec-approve-button deliver-button matspec-deliver-button'
                }
                style={{ color: '#3498DB', height: '21px' }}
                onClick={(e) => this.shouldMatspecDeliver(e, currentMatspec)}
              >
                <span
                  className="matspec-approve-text"
                  data-translationkey="deliver"
                >
                  <Icon type="loading" />
                  {translations.deliver ? translations.deliver : 'Deliver'}
                </span>
              </Button>
              {currentMatspec.status.code != 518 && (
                <Tooltip title={translations.approve} mouseEnterDelay={0.5}>
                  <a
                    href="#"
                    matspec-id={currentMatspec.id}
                    id={'matspecApproveButton.' + currentMatspec.id}
                    className={
                      currentMatspec.approve ||
                        !(
                          this.props.matspecsToSubmit &&
                          !this.props.matspecsToSubmit[currentMatspec.id]
                        )
                        ? 'matspec-header-btn btn-success matspec-approve-button'
                        : 'd-none'
                    }
                    style={{ color: '#2ECC71' }}
                    onClick={(e) => this.shouldMatspecApprove(currentMatspec, e)}
                  >
                    <Icon
                      className={
                        this.state.approving ? 'matspec-approve-icon' : 'd-none'
                      }
                      type="loading"
                    />
                    <span
                      className="matspec-approve-text"
                      data-translationkey="approve"
                    >
                      {translations.approve}
                    </span>
                    <span
                      className="matspec-approving-text"
                      data-translationkey="approving"
                    >
                      {translations.approving}
                    </span>
                  </a>
                </Tooltip>
              )}
              {this.props.internal && (
                <Tooltip
                  title={
                    translations.openInServer
                      ? translations.openInServer
                      : 'Open in Server'
                  }
                  mouseEnterDelay={0.5}
                >
                  <a
                    target="_blank"
                    href={currentMatspec.adserverurl}
                    style={{ verticalAlign: 'top' }}
                    className={
                      currentMatspec.adserverurl && this.props.internal
                        ? 'd-inline-block'
                        : 'v-hidden'
                    }
                  >
                    <img
                      src={
                        currentMatspec.adserverurl &&
                          currentMatspec.adserverurl.includes('xandr.com')
                          ? nexusLogo
                          : gam
                      }
                      alt="gam"
                      style={{ width: '25px' }}
                    />
                  </a>
                </Tooltip>
              )}
            </span>
            <Table
              pagination={false}
              onRow={(record, rowIndex) => {
                return {
                  onMouseEnter: (event) => {
                    //console.log(record.id)
                    if (dragStart) {
                      //console.log(dragStart);
                      currentHoveredCreative = record.id;
                      currentHoveredMatspec = record.materialSpecificationId;
                    }
                  },
                };
              }}
              dataSource={currentMatspec.admaterial}
              rowClassName={(record, index) =>
                'AdMaterial_' +
                record.id +
                ' printed-' +
                currentMatspec.printed +
                ' creativeRow rowDummy-' +
                record.dummy
              }
              columns={columns}
              onChange={this.onChange}
              size="small"
              defaultExpandAllRows={this.props.bigpreviewMode}
              expandedRowRender={(record) => {
                if (record.bigpreview)
                  return (
                    <img
                      src={imageUrlPath + record.bigpreview.url}
                      alt="bigpreview"
                    />
                  );
                if (record.original && record.original[0])
                  return (
                    <img
                      src={imageUrlPath + record.original[0].url}
                      alt="original"
                    />
                  );
              }}
            />
          </Panel>
        );

      const currentMatspecStatus = this.props.loadConfig[
        'web.campaign.groupmatspecs'
      ]
        ? currentMatspec.campaigngroup
        : currentMatspec.status.code;
      let statusMatchConfig = false;
      const campaignSectionsStatusesAsArray = campaignSectionsStatuses
        .split(' ')
        .map(Number);
      for (let i = 0; i < campaignSectionsStatusesAsArray.length; i++) {
        if (currentMatspecStatus === campaignSectionsStatusesAsArray[i]) {
          statusMatchConfig = true;
          break;
        }
      }
      if (campaignSectionsFinal)
        for (let x = 0; x < campaignSectionsFinal.length; x++) {
          if (!sections[x]) sections[x] = [];
          const currentSection = campaignSectionsFinal[x];
          if (currentSection.statuses) {
            const array = currentSection.statuses.split(' ').map(Number);
            //console.log(array)
            let match = false;
            for (let z = 0; z < array.length; z++) {
              if (array[z] === currentMatspecStatus) match = true;
              // DavidP this needs to be fixed for 1700 error
              // console.log(array[z], currentMatspecStatus, match);
            }
            // console.log(match, campaignSectionsStatuses);

            if (match && campaignSectionsStatuses) {
              sections[x].push(
                <Panel
                  className={
                    currentMatspec.archived
                      ? 'creative-type creative-type-' +
                      currentMatspecCreativetype +
                      ' creative-archived-true ' +
                      showArchived
                      : 'creative-type creative-type-' +
                      currentMatspecCreativetype +
                      ' creative-archived-false ' +
                      showArchived
                  }
                  id={'matspecPanel.' + currentMatspec.id}
                  header={
                    <MatspecHeader
                      randomNumber={this.state.randomNumber}
                      currentTabKey={this.props.currentTabKey}
                      handleMatSpecCheck={this.handleMatSpecCheck}
                      statuses={statuses}
                      multiUploadChecked={this.props.multiUploadChecked}
                      config={config}
                      translations={translations}
                      currentMatspec={currentMatspec}
                      creativesToReview={creativesToReview}
                      creativesLength={creativesLength}
                      singleAd={this.props.singleAd}
                      checkedMatspecsArray={this.props.checkedMatspecsArray}
                    />
                  }
                  key={currentMatspec.id}
                >
                  <span className="matspec-header-btn-container">
                    {currentMatspec.admaterial[0] &&
                      currentMatspec.admaterial[0].actions &&
                      currentMatspec.admaterial[0].actions.DOWNLOAD && (
                        <a
                          data-translationkey="download"
                          href="#"
                          id={'downloadMatspec.' + currentMatspec.id}
                          matspec-id={currentMatspec.id}
                          className={'matspec-header-btn download-matspec'}
                          onClick={(e) =>
                            this.downloadMatspec(e, currentMatspec.id)
                          }
                        >
                          {translations.download}
                        </a>
                      )}
                    <a
                      id={'addCreative.' + currentMatspec.id}
                      data-translationkey="addCreative"
                      href="#"
                      matspec-id={currentMatspec.id}
                      className={
                        currentMatspec.printed
                          ? 'd-none'
                          : 'matspec-header-btn add-creative-btn'
                      }
                      onClick={this.addCreative}
                    >
                      {translations.addCreative}
                    </a>
                    <Button
                      loading={this.state.matspecIsDelivering}
                      matspec-id={currentMatspec.id}
                      id={'matspecDeliverButton.' + currentMatspec.id}
                      className={
                        !currentMatspec.showDeliverButton
                          ? 'd-none'
                          : 'matspec-header-btn btn-success matspec-approve-button deliver-button matspec-deliver-button'
                      }
                      style={{
                        color: '#3498DB',
                        height: '21px',
                      }}
                      onClick={(e) =>
                        this.shouldMatspecDeliver(e, currentMatspec)
                      }
                    >
                      <span
                        className="matspec-approve-text"
                        data-translationkey="deliver"
                      >
                        <Icon type="loading" />
                        {translations.deliver
                          ? translations.deliver
                          : 'Deliver'}
                      </span>
                    </Button>
                    {currentMatspec.status.code != 518 && (
                      <Tooltip title={translations.approve} mouseEnterDelay={0.5}>
                        <a
                          href="#"
                          matspec-id={currentMatspec.id}
                          id={'matspecApproveButton.' + currentMatspec.id}
                          className={
                            currentMatspec.approve ||
                              !(
                                this.props.matspecsToSubmit &&
                                !this.props.matspecsToSubmit[currentMatspec.id]
                              )
                              ? 'matspec-header-btn btn-success matspec-approve-button'
                              : 'd-none'
                          }
                          style={{ color: '#2ECC71' }}
                          onClick={(e) =>
                            this.shouldMatspecApprove(currentMatspec, e)
                          }
                        >
                          <Icon
                            className={
                              this.state.approving
                                ? 'matspec-approve-icon'
                                : 'd-none'
                            }
                            type="loading"
                          />
                          <span
                            className="matspec-approve-text"
                            data-translationkey="approve"
                          >
                            {translations.approve}
                          </span>
                          <span
                            className="matspec-approving-text"
                            data-translationkey="approving"
                          >
                            {translations.approving}
                          </span>
                        </a>
                      </Tooltip>
                    )}

                    {this.props.internal && (
                      <Tooltip
                        title={
                          translations.openInServer
                            ? translations.openInServer
                            : 'Open in Server'
                        }
                        mouseEnterDelay={0.5}
                      >
                        <a
                          target="_blank"
                          href={currentMatspec.adserverurl}
                          className={
                            currentMatspec.adserverurl
                              ? 'd-inline-block'
                              : ' v-hidden'
                          }
                        >
                          <img
                            src={
                              currentMatspec.adserverurl &&
                                currentMatspec.adserverurl.includes(
                                  'xandr.com'
                                )
                                ? nexusLogo
                                : gam
                            }
                            alt="gam"
                            style={{
                              width: '25px',
                            }}
                          />
                        </a>
                      </Tooltip>
                    )}
                  </span>
                  <Table
                    pagination={false}
                    onRow={(record, rowIndex) => {
                      return {
                        onMouseEnter: (event) => {
                          if (dragStart) {
                            //console.log(dragStart);
                            currentHoveredCreative = record.id;
                            currentHoveredMatspec =
                              record.materialSpecificationId;
                          }
                        },
                      };
                    }}
                    dataSource={currentMatspec.admaterial}
                    rowClassName={(record, index) =>
                      'AdMaterial_' +
                      record.id +
                      ' printed-' +
                      currentMatspec.printed +
                      ' creativeRow rowDummy-' +
                      record.dummy
                    }
                    columns={columns}
                    onChange={this.onChange}
                    size="small"
                    defaultExpandAllRows={this.props.bigpreviewMode}
                    expandedRowRender={(record) => {
                      if (record.bigpreview)
                        return (
                          <img
                            src={imageUrlPath + record.bigpreview.url}
                            alt="bigpreview"
                          />
                        );
                      if (record.original && record.original[0])
                        return (
                          <img
                            src={imageUrlPath + record.original[0].url}
                            alt="original"
                          />
                        );
                    }}
                  />
                </Panel>
              );
            }
          } else if (campaignSectionsStatuses && !statusMatchConfig) {
            sections[x].push(
              <Panel
                className={
                  currentMatspec.archived
                    ? 'creative-type creative-type-' +
                    currentMatspecCreativetype +
                    ' creative-archived-true ' +
                    showArchived
                    : 'creative-type creative-type-' +
                    currentMatspecCreativetype +
                    ' creative-archived-false ' +
                    showArchived
                }
                id={'matspecPanel.' + currentMatspec.id}
                header={
                  <MatspecHeader
                    randomNumber={this.state.randomNumber}
                    handleMatSpecCheck={this.handleMatSpecCheck}
                    multiUploadChecked={this.props.multiUploadChecked}
                    currentTabKey={this.props.currentTabKey}
                    statuses={statuses}
                    config={config}
                    translations={translations}
                    currentMatspec={currentMatspec}
                    creativesToReview={creativesToReview}
                    creativesLength={creativesLength}
                    singleAd={this.props.singleAd}
                    checkedMatspecsArray={this.props.checkedMatspecsArray}
                  />
                }
                key={currentMatspec.id}
              >
                <span className="matspec-header-btn-container">
                  {currentMatspec.admaterial[0] &&
                    currentMatspec.admaterial[0].actions &&
                    currentMatspec.admaterial[0].actions.DOWNLOAD && (
                      <a
                        data-translationkey="download"
                        href="#"
                        id={'downloadMatspec.' + currentMatspec.id}
                        matspec-id={currentMatspec.id}
                        className={'matspec-header-btn download-matspec'}
                        onClick={(e) =>
                          this.downloadMatspec(e, currentMatspec.id)
                        }
                      >
                        {translations.download}
                      </a>
                    )}
                  <a
                    id={'addCreative.' + currentMatspec.id}
                    data-translationkey="addCreative"
                    href="#"
                    matspec-id={currentMatspec.id}
                    className={
                      currentMatspec.printed
                        ? 'd-none'
                        : 'matspec-header-btn add-creative-btn'
                    }
                    onClick={this.addCreative}
                  >
                    {translations.addCreative}
                  </a>
                  <Button
                    loading={this.state.matspecIsDelivering}
                    matspec-id={currentMatspec.id}
                    id={'matspecDeliverButton.' + currentMatspec.id}
                    className={
                      !currentMatspec.showDeliverButton
                        ? 'd-none'
                        : 'matspec-header-btn btn-success matspec-approve-button deliver-button matspec-deliver-button'
                    }
                    style={{
                      color: '#3498DB',
                      height: '21px',
                    }}
                    onClick={(e) =>
                      this.shouldMatspecDeliver(e, currentMatspec)
                    }
                  >
                    <span
                      className="matspec-approve-text"
                      data-translationkey="deliver"
                    >
                      {' '}
                      <Icon type="loading" />
                      {translations.deliver ? translations.deliver : 'Deliver'}
                    </span>
                  </Button>
                  {currentMatspec.status.code != 518 && (
                    <Tooltip title={translations.approve} mouseEnterDelay={0.5}>
                      <a
                        href="#"
                        matspec-id={currentMatspec.id}
                        id={'matspecApproveButton.' + currentMatspec.id}
                        className={
                          currentMatspec.approve ||
                            !(
                              this.props.matspecsToSubmit &&
                              !this.props.matspecsToSubmit[currentMatspec.id]
                            )
                            ? 'matspec-header-btn btn-success matspec-approve-button'
                            : 'd-none'
                        }
                        style={{ color: '#2ECC71' }}
                        onClick={(e) =>
                          this.shouldMatspecApprove(currentMatspec, e)
                        }
                      >
                        <Icon
                          className={
                            this.state.approving
                              ? 'matspec-approve-icon'
                              : 'd-none'
                          }
                          type="loading"
                        />
                        <span
                          className="matspec-approve-text"
                          data-translationkey="approve"
                        >
                          {translations.approve}
                        </span>
                        <span
                          className="matspec-approving-text"
                          data-translationkey="approving"
                        >
                          {translations.approving}
                        </span>
                      </a>
                    </Tooltip> 
                  )}

                  {this.props.internal && (
                    <Tooltip
                      title={
                        translations.openInServer
                          ? translations.openInServer
                          : 'Open in Server'
                      }
                      mouseEnterDelay={0.5}
                    >
                      <a
                        target="_blank"
                        href={currentMatspec.adserverurl}
                        className={
                          currentMatspec.adserverurl
                            ? 'd-inline-block'
                            : ' v-hidden'
                        }
                      >
                        <img
                          src={
                            currentMatspec.adserverurl &&
                              currentMatspec.adserverurl.includes('xandr.com')
                              ? nexusLogo
                              : gam
                          }
                          alt="gam"
                          style={{ width: '25px' }}
                        />
                      </a>
                    </Tooltip>
                  )}
                </span>
                <Table
                  pagination={false}
                  onRow={(record, rowIndex) => {
                    return {
                      onMouseEnter: (event) => {
                        if (dragStart) {
                          //console.log(dragStart);
                          currentHoveredCreative = record.id;
                          currentHoveredMatspec =
                            record.materialSpecificationId;
                        }
                      },
                    };
                  }}
                  dataSource={currentMatspec.admaterial}
                  rowClassName={(record, index) =>
                    'AdMaterial_' +
                    record.id +
                    ' printed-' +
                    currentMatspec.printed +
                    ' creativeRow rowDummy-' +
                    record.dummy
                  }
                  columns={columns}
                  onChange={this.onChange}
                  size="small"
                  defaultExpandAllRows={this.props.bigpreviewMode}
                  expandedRowRender={(record) => {
                    if (record.bigpreview)
                      return (
                        <img
                          src={imageUrlPath + record.bigpreview.url}
                          alt="bigpreview"
                        />
                      );
                    if (record.original && record.original[0])
                      return (
                        <img
                          src={imageUrlPath + record.original[0].url}
                          alt="original"
                        />
                      );
                  }}
                />
              </Panel>
            );
          }
        }
    }
    if (campaignSectionsFinal)
      for (let x = 0; x < campaignSectionsFinal.length; x++) {
        var s = campaignSectionsFinal[x].name;
        var matches = [];
        var pattern = /\{(.*?)\}/g;
        var match;
        while ((match = pattern.exec(s)) != null) matches.push(match[1]);
        if (matches.length > 0)
          for (let z = 0; z < matches.length; z++) {
            const key = matches[z];
            if (this.props.translations)
              campaignSectionsFinal[x].name = campaignSectionsFinal[x].name
                .replace(matches[z], this.props.translations[key])
                .replace(
                  '{',
                  '<span className="header-lang" data-langid=' + key + '>'
                )
                .replace('}', '</span>')
                .replace('undefined', key);
          }
        if (sections && sections[x] && sections[x].length > 0) {
          newPanels.push(
            <div className="section-container" key={x}>
              <p className="section-header">
                {campaignSectionsFinal[x]
                  ? this.props.translations[campaignSectionsFinal[x].name]
                    ? this.props.translations[campaignSectionsFinal[x].name]
                    : Parser(campaignSectionsFinal[x].name)
                  : 'null'}
              </p>
              {this.state.config &&
                this.state.config['web.campaign.groupMatspecsUpload'] && (
                  <Checkbox
                    disabled={this.props.multiUploadChecked}
                    id={x}
                    onClick={(e) => this.handleMultiChecked(e, 'group')}
                    className="group-checkbox"
                  >
                    {this.props.translations.selectAll || 'Select for multiupload'}
                  </Checkbox>
                )}
              <MatspecSectionHeader
                currentTabKey={this.props.currentTabKey}
                config={this.props.loadConfig}
                translations={this.props.translations}
                fieldTranslations={this.props.fieldTranslations}
                showExpandAll={showExpandAll}
                toggleAllCollapse={this.toggleAllCollapse}
                collapseAllOpen={collapseAllOpen}
              />
              <Collapse
                defaultActiveKey={defaultActiveKey}
                key={defaultActiveKey.join()}
                onChange={(key) => this.onMatspecPanelChange(key)}
              >
                {sections[x]}
              </Collapse>
            </div>
          );
        }
      }

    let containers = document.getElementsByClassName('section-container');
    for (var i = 0; i < containers.length; i++)
      if (!containers[i].lastChild.hasChildNodes())
        containers[i].setAttribute('style', 'display: none');
    // console.log(
    //   this.state.config,
    //   this.state.config.web_campaign_sections,
    //   this.state.web_campaign_sections_internal,
    //   newPanels,
    //   campaignSectionsFinal
    // );

    if (this.props.bookingLoaded && this.state.config) {
      if (this.state.config['web.campaign.groupmatspecs']) {
        return (
          <div id="matspecContainer" className="ix-matspec paginated">
            {newPanels}
          </div>
        );
      }
      return (
        <div id="matspecContainer" className="ix-matspec paginated">
          {(this.state.config.web_campaign_sections &&
            this.state.config.web_campaign_sections.length > 0) ||
            (this.state.config.web_campaign_sections_internal &&
              this.state.config.web_campaign_sections_internal.length > 0) ? (
              newPanels
            ) : (
              <span>
                <MatspecSectionHeader
                  currentTabKey={this.props.currentTabKey}
                  config={this.props.loadConfig}
                  translations={this.props.translations}
                  fieldTranslations={this.props.fieldTranslations}
                  showExpandAll={showExpandAll}
                  toggleAllCollapse={this.toggleAllCollapse}
                  collapseAllOpen={collapseAllOpen}
                />
                <Collapse
                  defaultActiveKey={defaultActiveKey}
                  key={defaultActiveKey.join()}
                  onChange={(key) => this.onMatspecPanelChange(key)}
                >
                  {panelsArray}
                </Collapse>
              </span>
            )}
          <Modal
            title="Preview"
            visible={this.state.visible}
            onOk={this.handleCancel}
            onCancel={this.handleCancel}
          >
            <img
              style={{ width: '100%' }}
              src={this.state.previewUrl}
              alt="preview"
            />
          </Modal>
        </div>
      );
    } else {
      return null;
    }
  }

  setDraggableCreatives = () => {
    const draggies = [];
    let draggableCreatives = null;
    let draggie = null;
    const comp = this;

    draggableCreatives = document.querySelectorAll('.ad-thumbnail');
    for (var i = 0; i < draggableCreatives.length; i++) {
      let draggableElem = draggableCreatives[i];
      draggableElem.setAttribute('draggable', true);
      draggie = new Draggabilly(draggableElem, {
        containment: '#matspecContainer',
      });

      draggie.on('dragStart', async (event, pointer) => {
        const target = event.target;
        document
          .getElementById('matspecContainer')
          .classList.add('cursor-grabbing');
        const setStyles = () => {
          target.style.left = event.clientX + 5 + 'px';
          target.style.top = event.clientY + 5 + 'px';
          target.style.zIndex = '99';
          target.style.position = 'fixed';
          target.style.border = '2px dashed #aaa';
        };
        await setStyles();
        dragStart = true;
        const adId = target.id.replace('adThumbnail.', '');
        currentHoveredCreative = dragStartCreative = parseInt(adId, 10);
        currentDragTarget = target;
        //console.log(dragStartCreative);
      });

      draggie.on('dragEnd', async (event, pointer) => {
        //target.closest('.creativeRow').style.cursor = 'default';
        await currentDragTarget.removeAttribute('style');
        document
          .getElementById('matspecContainer')
          .classList.remove('cursor-grabbing');
        dragStart = false;
        dragEndCreative = currentHoveredCreative;
        //console.log(dragStartCreative, dragEndCreative);
        /*currentDragTarget.style.top = "0px";
        currentDragTarget.style.left = "0px";*/
        /*currentDragTarget.style.position = "relative";
        currentDragTarget.style.zIndex = "initial";
        currentDragTarget.style.width = "initial";
        currentDragTarget.style.height = "initial";*/
        //console.log('drag end' , currentDragTarget);
        //console.log(dragEndCreative);
        comp.swapMaterials(dragStartCreative, dragEndCreative);
        currentHoveredCreative = NaN;
      });
      draggies.push(draggie);
    }
  };

  swapMaterials = (dragStartCreative, dragEndCreative) => {
    const { translations } = this.props;
    //console.log(dragStartCreative, dragEndCreative);
    if (!Number.isNaN(dragStartCreative) && !Number.isNaN(dragEndCreative)) {
      if (dragStartCreative !== dragEndCreative) {
        tempModal = Modal.info({
          className: 'swap-modal',
          title: translations.swapping,
          content: (
            <div>
              <p className="materials-swapping-text">
                {translations.swappingMaterials}{' '}
                <Icon style={{ marginLeft: '5px' }} type="loading" />
                <br />
                <strong>{translations.from || 'From'}</strong>
                {': '}
                {dragStartCreative}
                <br />
                <strong>{translations.to || 'To'}</strong>
                {': '}
                {dragEndCreative}
              </p>
            </div>
          ),
        });
        fetch(
          urlPath +
          '/api/swapadmaterials?admaterial1=' +
          dragStartCreative +
          '&admaterial2=' +
          dragEndCreative,
          {
            method: 'POST',
            credentials: 'include',
            headers: getAuthHeader(),
          }
        )
          .then((response) => {
            //console.log("admaterial Swap", response.text());
            this.loadSwappedMaterials(dragStartCreative, dragEndCreative);
          })
          .catch((e) => console.error('Cannot Swap', e));
      }
    } else {
      tempModal = Modal.error({
        className: 'swap-modal swap-modal-error',
        title: translations.swapping,
        keyboard: false,
        content: (
          <div>
            <p className="materials-swapping-text">
              {translations.somethingWrong}. {translations.appWillReload}.
            </p>
            <p className="materials-swapping-text" />
          </div>
        ),
        onOk: () => {
          window.location.reload();
        },
      });
    }
  };

  loadSwappedMaterials = (dragStartCreative, dragEndCreative) => {
    this.updateBooking(currentHoveredMatspec, false);
    //setTimeout(() => tempModal.destroy() , 500)
    //this.progressMaterialRow(currentHoveredMatspec, dragStartCreative);
    //this.progressMaterialRow(currentHoveredMatspec, dragEndCreative);
    //this.loadAdSwappedMaterial(dragStartCreative);
    //this.loadAdSwappedMaterial(dragEndCreative);
  };

  getMatspecGroups = (matspecs) => {
    let groups = matspecs.map((matspec) => matspec.campaigngroup);
    groups = removeDuplicatedFromArray(groups);
    const groupedMatpspecs = groups.map((group) =>
      matspecs.filter((matspec) => matspec.campaigngroup === group)
    );
    groups = groups.sort();
    const aliasStatuses = groups.toString().replace(',', ' ');
    const aliasCampaignSectionsStatuses = groups.map((item) => {
      return {
        name: (this.props.translations.group || 'Group') + ' ' + item,
        statuses: item.toString(),
      };
    });
    return { aliasStatuses, aliasCampaignSectionsStatuses };
  };

  componentWillMount() {
    function setConfig(data) {
      //console.log(this.state.internal ? "Is internal" : "Is customer");
      this.props.setConfig(data);
      let campaignSections = null;
      if (this.props.internal && data.web_campaign_sections_internal)
        campaignSections = data.web_campaign_sections_internal;
      else campaignSections = data.web_campaign_sections;
      this.setState({ config: data, campaignSections: campaignSections });
      const campaignSectionsArray =
        campaignSections && campaignSections.split(',');
      const campaignSectionsArrayFormatted = [];
      let campaignSectionsFinal = [];
      let campaignSectionsStatuses = '';
      //console.log('campaignSectionsArray' , campaignSectionsArray)
      for (let i = 0; i < campaignSectionsArray.length; i++)
        campaignSectionsArrayFormatted.push(
          campaignSectionsArray[i].split('#')
        );
      for (let i = 0; i < campaignSectionsArrayFormatted.length; i++) {
        const key = campaignSectionsArrayFormatted[i][0];
        const findKey = key.match(/{([^}]+)}/) && key.match(/{([^}]+)}/)[1];
        const translatedKey = findKey
          ? findKey
          : campaignSectionsArrayFormatted[i][0];
        //console.log("translatedKey", this.props.translations[translatedKey]);
        campaignSectionsFinal.push({
          name: translatedKey,
          statuses: campaignSectionsArrayFormatted[i][1],
        });
        if (campaignSectionsArrayFormatted[i][1])
          campaignSectionsStatuses += campaignSectionsArrayFormatted[i][1];
      }

      if (data['web.campaign.groupmatspecs']) {
        const {
          aliasStatuses,
          aliasCampaignSectionsStatuses,
        } = this.getMatspecGroups(this.props.loadBookingData.matspecs);
        campaignSectionsFinal = aliasCampaignSectionsStatuses;
        campaignSectionsStatuses = aliasStatuses;
        //console.log("campaignSectionsFinal", campaignSectionsFinal);
        //console.log("campaignSectionsStatuses", campaignSectionsStatuses);
      }
      this.setState({
        campaignSectionsFinal: campaignSectionsFinal,
        campaignSectionsStatuses: campaignSectionsStatuses,
      });
      fetch(
        urlPath +
        '/api/noauth/loadallstatuses?language=' +
        this.props.languageCode
      )
        .then((response) => response.json())
        .then((data) => {
          //console.log("Loaded all statuses");
          this.setState({ statuses: data });
          this.setState({ isInitialized: true });
          this.shouldAddDummy();

        })
        .catch((e) => console.error('Cannot load statuses', e));

      const { matspecsBooking } = this.props;

      matspecsBooking.map(
        (matspec) =>
          !matspec.printed &&
          data['web.uploadadmaterial.dummycreative'] &&
          (data['web.uploadadmaterial.showmultipledummycreatives'] || !matspec.admaterial.filter((ad) => isAdFilledWithData(ad)).length) &&
          matspec.admaterial.push(
            this.createDummyCreative(matspec.productionad)
          )
      );
      if (data['web.uploadadmaterial.swap'])
        setTimeout(() => this.setDraggableCreatives(), 2500);
    }
    setConfig.call(this, this.props.loadConfigVal);
  }

  scrollView = (specId) => {
    let currentMaterialSpecificationPanel = null;
    // console.log("scroll triggered:", specId);
    if (specId) {
      currentMaterialSpecificationPanel = document.getElementById(
        'matspecPanel.' + specId
      );
    } else {
      currentMaterialSpecificationPanel = document.getElementById(
        'matspecPanel.' + this.props.currentMaterialSpecification
      );
    }
    if (currentMaterialSpecificationPanel) {
      currentMaterialSpecificationPanel.scrollIntoView();
    }
    setTimeout(() => this.setState({ scrollViewTriggered: true }), 1000);
  };

  shouldAddDummy = () => {
    const { matspecsBooking, specId: matspecId, loadConfig } = this.props;
  // if (loadConfig['web.uploadadmaterial.showmultipledummycreatives']) {

  //     const currentMatspec = matspecsBooking.find((b) => b.id === matspecId)

  //     if (currentMatspec) {
  //       const withEmptyMatFileCount = currentMatspec.admaterial.filter(
  //         (_) => _.matfilecount === 0
  //       );
  //       if (withEmptyMatFileCount.length > 0) {
  //         const x = withEmptyMatFileCount.filter((_) => !_.text).length === 0;
  //         if (x) {
  //           currentMatspec.admaterial.push(
  //             this.createDummyCreative(currentMatspec.productionad)
  //           );
  //           this.setState({ matspecsBooking: matspecsBooking });
  //         }
  //       }
  //     }
  //   }
  }

  componentDidUpdate(prevProps) {
    const { isInitialized, scrollViewTriggered } = this.state;
    const {
      specId,
      detailsVisible,
      currentMatspecId,
      scrollY,
      openedMatspec,
      shouldRefreshBooking,
    } = this.props;

    if (isInitialized && !scrollViewTriggered) {
      let activeMatspecs = sessionStorage.getItem('activeMatspecs');
      //if (this.props.scrollY) window.scrollTo(0, this.props.scrollY);
      //console.log("scrolling into", this.props.specId);
      if (activeMatspecs === '') activeMatspecs = null;
      if (activeMatspecs) {
        const whichSpecIdToZoom = activeMatspecs
          .split(',')
          .slice(-1)[0]
          .replace('matspecPanel.', '');
        this.scrollView(parseInt(whichSpecIdToZoom, 10));
      } else {
        this.scrollView(specId);
      }
      setInitialBodyZoom();

      /* const currentMatspecIdPanel = document
                .getElementById("matspecPanel." + specId)
                .querySelector("#matspecHeaderContent");
            setTimeout(() => { if (
        activeMatspecs && currentMatspecIdPanel &&
        !currentMatspecIdPanel.hasAttribute("data-clicked") &&
        !currentMatspecIdPanel.classList.contains("ant-collapse-item-active")
      ) {
        currentMatspecIdPanel.click();
        currentMatspecIdPanel.setAttribute("data-clicked", true);
      }} , 500) */
    }
    if (prevProps.detailsVisible !== detailsVisible) {
      //console.log("prevProps", prevProps.detailsVisible);
      //console.log("props", detailsVisible);
      if (!detailsVisible) {
        this.updateBooking(currentMatspecId, true);
        if (scrollY) window.scrollTo(0, scrollY);
        //this.scrollView(openedMatspec);
      }
    }
    if (
      prevProps.shouldRefreshBooking !== shouldRefreshBooking &&
      shouldRefreshBooking
    ) {
      this.updateBooking(specId, true);
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Matspec);



// WEBPACK FOOTER //
// ./src/components/Matspec.js